import { dom } from "@fortawesome/fontawesome-svg-core";
import Point from "./classes/Point";
import ReadOnlyService from "./services/ReadOnlyService";
import InfoService from "./services/InfoService";
import ThrottlingService from "./services/ThrottlingService";
import ConfigService from "./services/ConfigService";
import html2canvas from "html2canvas";
import DOMPurify from "dompurify";

const RAD_TO_DEG = 180.0 / Math.PI;
const DEG_TO_RAD = Math.PI / 180.0;
const _45_DEG_IN_RAD = 45 * DEG_TO_RAD;

const whiteboard = {
  canvas: null,
  ctx: null,
  drawcolor: "black",
  previousToolHtmlElem: null, // useful for handling read-only mode
  tool: "mouse",
  thickness: 4,
  /**
   * @type Point
   */
  prevPos: new Point(0, 0),
  /**
   * @type Point
   */
  startCoords: new Point(0, 0),
  viewCoords: { x: 0, y: 0 },
  tempCoords: { x: 0, y: 0 },
  drawFlag: false,
  oldGCO: null,
  mouseover: false,
  lineCap: "round", //butt, square
  backgroundGrid: null,
  canvasElement: null,
  cursorContainer: null,
  imgContainer: null,
  svgContainer: null, //For draw prev
  mouseOverlay: null,
  ownCursor: null,
  currentIndex: "",
  penSmoothLastCoords: [],
  svgLine: null,
  svgArrow: null,
  svgArrowFull: null,
  svgArrowHead: null,
  svgArrowMarker: null,
  svgArrowPath: null,
  svgRect: null,
  svgCirle: null,
  svgEllipse: null,
  resizeTimeout: null,
  resizeFinished: true,
  dbCp: [],
  fixedWidth: 0,
  fixedHeight: 0,
  containerEl: null,
  innerContainer: null,
  // 白板尺寸：寬度取容器當前寬度，高度取畫布當前高度（背景圖加載後可能大於容器）
  _boardWidth() {
    return this.containerEl ? this.containerEl.clientWidth : (this.canvas ? this.canvas.width : 0);
  },
  _boardHeight() {
    return this.canvas ? this.canvas.height : 0;
  },
  drawBuffer: [],
  pendingBuffer: [],
  undoBuffer: [],
  eraseHistory: {},
  imageWidth: null,
  imageHeight: null,
  drawId: 0, //Used for undo/redo functions
  imgDragActive: false,
  latestActiveTextBoxId: false, //The id of the latest clicked Textbox (for font and color change)
  pressedKeys: {},
  isVideoShow: false,
  settings: {
    whiteboardId: "0",
    username: "unknown",
    sendFunction: null,
    // backgroundGridUrl: `https://${window.location.hostname}:8998/images/bg_white.png`,
    backgroundGridUrl: `https://${window.location.host}/bg_white.png`,
  },
  backgroundUrl: `https://${window.location.host}/bg_white.png`,
  lastPointerSentTime: 0,
  /**
   * @type Point
   */
  lastPointerPosition: new Point(0, 0),
  loadWhiteboard: function (whiteboardContainer, newSettings) {
    const svgns = "http://www.w3.org/2000/svg";
    const _this = this;
    for (const i in newSettings) {
      this.settings[i] = newSettings[i];
    }
    this.settings["username"] = this.settings["username"].replace(
      /[^0-9a-z]/gi,
      ""
    );
    //background grid (repeating image) and smallest screen indication
    _this.backgroundGrid = $(
      `<div id="backgroundGrid" style="position: absolute; top:0; opacity: 0.2; background-image:url('${_this.settings["backgroundGridUrl"]}' z-index:0;); width: 100%; height: 100%;"></div>`
    );
    // container for background images
    _this.imgContainer = $(
      '<div id="imgContainer" style="position: absolute; top:0; height: 100%; width: 100%; z-index:0; display: flex; align-items: center; justify-content: center;"></div>'
    );
    // whiteboard canvas
    _this.canvasElement = $(
      '<canvas id="whiteboardCanvas" ref="whiteboardCanvas" style="position: absolute; top:0; cursor:crosshair; z-index:0;" ref="whiteboardCanvas"></canvas>'
    );
    // SVG container holding drawing or moving previews
    _this.svgContainer = $(
      '<svg id="svgContainer" style="position: absolute; top:0px;" width="100%" height="100%" z-index:0;></svg>'
    );
    // drag and drop indicator, hidden by default
    _this.dropIndicator = $(
      '<div id="dropIndicator" style="position:absolute; height: 100%; width: 100%; border: 7px dashed gray; text-align: center; top: 0px; color: gray; font-size: 23em; display: none; z-index:0;"><i class="far fa-plus-square" aria-hidden="true"></i></div>'
    );
    // container for other users cursors
    _this.cursorContainer = $(
      '<div id="cursorContainer" style="position: absolute; top:0; height: 100%; width: 100%; z-index:0;"></div>'
    );
    // container for texts by users
    _this.textContainer = $(
      '<div id="textContainer" class="textcontainer" style="position: absolute; top:0; height: 100%; width: 100%; cursor:text; z-index:0;"></div>'
    );
    // mouse overlay for draw callbacks
    _this.mouseOverlay = $(
      '<div id="mouseOverlay" style="cursor:none; position: absolute; top:0; height: 100%; width: 100%; z-index:0;"></div>'
    );

    // 保存容器元素引用，用於動態查詢當前尺寸
    _this.containerEl = $(whiteboardContainer)[0];

    // 創建內部容器，讓所有覆蓋層與畫布保持一致大小
    // 初始為 100%，背景圖加載後由 adjustBackgroundPosition 動態調整
    _this.innerContainer = $(
      '<div id="whiteboardInner" style="width: 100%; height: 100%;"></div>'
    );

    $(whiteboardContainer).append(_this.innerContainer);

    _this.innerContainer
      .append(_this.backgroundGrid)
      .append(_this.imgContainer)
      .append(_this.canvasElement)
      .append(_this.svgContainer)
      .append(_this.dropIndicator)
      .append(_this.cursorContainer)
      .append(_this.textContainer)
      .append(_this.mouseOverlay);

    // render newly added icons
    let elements = document.getElementsByClassName("toolbar");

    for (let i = 0; i < elements.length; i++) {
      dom.i2svg({ node: elements[i] });
    }

    this.canvas = $("#whiteboardCanvas")[0];
    this.canvas.width = $(_this.containerEl).width();
    this.canvas.height = $(_this.containerEl).height();

    this.ctx = this.canvas.getContext("2d");
    this.oldGCO = this.ctx.globalCompositeOperation;

    window.addEventListener("resize", function () {
      clearTimeout(_this.resizeTimeout);
      _this.resizeTimeout = setTimeout(function () {
        // 視窗縮放時不調整白板尺寸，保持內容大小比例不變
        // whiteboardContainer 有 overflow: auto，超出容器時自動顯示捲動條
      }, 200);
    });

    $(_this.mouseOverlay).on("pointerdown", function (e) {
      if ($(e.target).closest(".dragMe").length > 0) {
        return; // Don't interfere with draggable elements
      }

      e.preventDefault();
      try {
        e.target.setPointerCapture(e.pointerId);
      } catch (err) {
        console.warn("setPointerCapture error:", err);
      }

      _this.mousedown(e);
    });

    _this.mousedown = function (e) {
      if (_this.imgDragActive || _this.drawFlag) {
        return;
      }
      if (ReadOnlyService.readOnlyActive) return;

      _this.drawFlag = true;

      const currentPos = Point.fromEvent(e);

      if (_this.tool === "pen") {
        _this.penSmoothLastCoords = [
          currentPos.x,
          currentPos.y,
          currentPos.x,
          currentPos.y,
          currentPos.x,
          currentPos.y,
        ];
      } else if (_this.tool === "hand") {
        _this.startCoords = currentPos;
      } else if (_this.tool === "eraser") {
        var width = _this._boardWidth();
        var height = _this._boardHeight();
        var size = [width, height];
        _this.drawEraserLine(
          size,
          currentPos.x,
          currentPos.y,
          currentPos.x,
          currentPos.y,
          _this.thickness
        );
        _this.sendFunction({
          t: _this.tool,
          d: [
            currentPos.x - _this.viewCoords.x,
            currentPos.y - _this.viewCoords.y,
            currentPos.x - _this.viewCoords.x,
            currentPos.y - _this.viewCoords.y,
          ],
          th: _this.thickness,
          s: size,
        });
      } else if (_this.tool === "line") {
        _this.startCoords = currentPos;
        _this.svgLine = document.createElementNS(svgns, "line");
        _this.svgLine.setAttribute("stroke", "gray");
        _this.svgLine.setAttribute("stroke-dasharray", "5, 5");
        _this.svgLine.setAttribute("x1", currentPos.x);
        _this.svgLine.setAttribute("y1", currentPos.y);
        _this.svgLine.setAttribute("x2", currentPos.x);
        _this.svgLine.setAttribute("y2", currentPos.y);
        _this.svgContainer.append(_this.svgLine);
      } else if (_this.tool === "arrow") {
        _this.startCoords = currentPos;
        _this.svgArrow = document.createElementNS(svgns, "line");
        _this.svgArrow.setAttribute("stroke", "gray");
        _this.svgArrow.setAttribute("stroke-dasharray", "5, 5");
        _this.svgArrow.setAttribute("x1", currentPos.x);
        _this.svgArrow.setAttribute("y1", currentPos.y);
        _this.svgArrow.setAttribute("x2", currentPos.x);
        _this.svgArrow.setAttribute("y2", currentPos.y);

        const markerSize = _this.thickness * 3.5;

        _this.svgArrowMarker = document.createElementNS(svgns, "marker");
        _this.svgArrowMarker.setAttribute("id", "arrow");
        _this.svgArrowMarker.setAttribute("markerWidth", markerSize);
        _this.svgArrowMarker.setAttribute("markerHeight", markerSize);
        _this.svgArrowMarker.setAttribute("refX", markerSize);
        _this.svgArrowMarker.setAttribute("refY", markerSize / 2);
        _this.svgArrowMarker.setAttribute("orient", "auto");
        _this.svgArrowMarker.setAttribute("stroke", "gray");
        _this.svgArrowMarker.setAttribute("stroke-dasharray", "5, 5");
        _this.svgArrowMarker.setAttribute("fill", "none");

        _this.svgArrowPath = document.createElementNS(svgns, "path");
        _this.svgArrowPath.setAttribute(
          "d",
          `M0,0 L${markerSize},${markerSize / 2} L0,${markerSize}`
        );
        _this.svgArrowPath.setAttribute("stroke", "gray");
        _this.svgArrowPath.setAttribute("stroke-dasharray", "5, 5");

        _this.svgArrowMarker.appendChild(_this.svgArrowPath);
        _this.svgContainer.append(_this.svgArrowMarker);
        _this.svgArrow.setAttribute("marker-end", "url(#arrow)");
        _this.svgContainer.append(_this.svgArrow);
      } else if (_this.tool === "rect" || _this.tool === "recSelect") {
        _this.svgContainer.find("rect").remove();
        _this.svgRect = document.createElementNS(svgns, "rect");
        _this.svgRect.setAttribute("stroke", "gray");
        _this.svgRect.setAttribute("stroke-dasharray", "5, 5");
        _this.svgRect.setAttribute("style", "fill-opacity:0.0;");
        _this.svgRect.setAttribute("x", currentPos.x);
        _this.svgRect.setAttribute("y", currentPos.y);
        _this.svgRect.setAttribute("width", 0);
        _this.svgRect.setAttribute("height", 0);
        _this.svgContainer.append(_this.svgRect);
        _this.startCoords = currentPos;
      } else if (_this.tool === "circle") {
        // _this.svgCirle = document.createElementNS(svgns, "circle");
        // _this.svgCirle.setAttribute("stroke", "gray");
        // _this.svgCirle.setAttribute("stroke-dasharray", "5, 5");
        // _this.svgCirle.setAttribute("style", "fill-opacity:0.0;");
        // _this.svgCirle.setAttribute("cx", currentPos.x);
        // _this.svgCirle.setAttribute("cy", currentPos.y);
        // _this.svgCirle.setAttribute("r", 0);
        // _this.svgContainer.append(_this.svgCirle);
        // _this.startCoords = currentPos;
        _this.svgCirle = document.createElementNS(svgns, "ellipse");
        _this.svgCirle.setAttribute("stroke", "gray");
        _this.svgCirle.setAttribute("stroke-dasharray", "5, 5");
        _this.svgCirle.setAttribute("style", "fill-opacity:0.0;");
        _this.svgCirle.setAttribute("rx", 10); // Set initial horizontal radius
        _this.svgCirle.setAttribute("ry", 10); // Set initial vertical radius
        _this.svgContainer.append(_this.svgCirle);
        _this.startCoords = currentPos;
      } else if (_this.tool === "ellipse") {
        _this.svgEllipse = document.createElementNS(svgns, "ellipse");
        _this.svgEllipse.setAttribute("stroke", "gray");
        _this.svgEllipse.setAttribute("stroke-dasharray", "5, 5");
        _this.svgEllipse.setAttribute("style", "fill-opacity:0.0;");
        _this.svgEllipse.setAttribute("rx", 10); // Set initial horizontal radius
        _this.svgEllipse.setAttribute("ry", 10); // Set initial vertical radius
        _this.svgContainer.append(_this.svgEllipse);
        _this.startCoords = currentPos;
      } else if (_this.tool === "triangle") {
        _this.svgTriangle = document.createElementNS(svgns, "polygon");
        _this.svgTriangle.setAttribute("stroke", "gray");
        _this.svgTriangle.setAttribute("stroke-dasharray", "5, 5");
        _this.svgTriangle.setAttribute("style", "fill-opacity:0.0;");
        _this.svgTriangle.setAttribute(
          "points",
          `${currentPos.x},${currentPos.y} ${currentPos.x},${currentPos.y} ${currentPos.x},${currentPos.y}`
        );
        _this.svgContainer.append(_this.svgTriangle);
        _this.startCoords = currentPos;
      }

      _this.prevPos = currentPos;
    };

    _this.textContainer.on("pointermove", function (e) {
      e.preventDefault();

      if (_this.imgDragActive || !$(e.target).hasClass("textcontainer")) {
        return;
      }
      if (ReadOnlyService.readOnlyActive) return;

      const currentPos = Point.fromEvent(e);
      const fontsize = _this.thickness * 0.5;
      var width = _this._boardWidth();
      var height = _this._boardHeight();
      var size = [width, height];
      var cursorHeightOffset = _this.getCursorHeight(fontsize) + 5;

      ThrottlingService.throttle(currentPos, () => {
        _this.lastPointerPosition = currentPos;
        _this.sendFunction({
          t: "cursor",
          event: "move",
          d: [currentPos.x, currentPos.y, width, height],
          username: _this.settings.username,
        });
      });
    });

    _this.mouseOverlay.on("pointermove", function (e) {
      if ($(e.target).closest(".dragMe").length > 0) return;
      //Move hole canvas
      e.preventDefault();

      if (_this.tool == "hand" && _this.drawFlag) {
        let currentPos = Point.fromEvent(e);
        let xDif = _this.startCoords.x - currentPos.x;
        let yDif = _this.startCoords.y - currentPos.y;

        _this.viewCoords.x -= xDif;
        _this.viewCoords.y -= yDif;

        _this.startCoords.x = currentPos.x;
        _this.startCoords.y = currentPos.y;

        const dbCp = JSON.parse(JSON.stringify(_this.drawBuffer)); // Copy the buffer
        // 以當前畫布尺寸重設（設置 width/height 會清空畫布）
        var _cw = _this.canvas.width;
        var _ch = _this.canvas.height;
        _this.canvas.width = _cw;
        _this.canvas.height = _ch;
        _this.drawBuffer = [];
        _this.textContainer.empty();
        _this.imgContainer.empty();
        _this.loadData(dbCp); // draw old content in
      }

      if (ReadOnlyService.readOnlyActive) return;
      _this.triggerMouseMove(e);
    });

    _this.mouseOverlay.on("pointerup", function (e) {
      try {
        e.target.releasePointerCapture(e.pointerId);
      } catch (err) {
        console.warn("releasePointerCapture error", err);
      }
      _this.mouseup?.(e);
    });

    _this.mouseup = function (e) {
      if (_this.imgDragActive) {
        return;
      }
      if (ReadOnlyService.readOnlyActive) return;
      _this.drawFlag = false;
      _this.ctx.globalCompositeOperation = _this.oldGCO;

      let currentPos = Point.fromEvent(e);

      if (currentPos.isZeroZero) {
        _this.sendFunction({
          t: "cursor",
          event: "out",
          username: _this.settings.username,
        });
      }

      if (_this.tool === "line") {
        if (_this.pressedKeys.shift) {
          currentPos = _this.getRoundedAngles(currentPos);
        }
        var width = _this._boardWidth();
        var height = _this._boardHeight();
        var size = [width, height];

        _this.drawPenLine(
          size,
          currentPos.x,
          currentPos.y,
          _this.startCoords.x,
          _this.startCoords.y,
          _this.drawcolor,
          _this.thickness
        );
        _this.sendFunction({
          t: _this.tool,
          d: [
            currentPos.x - _this.viewCoords.x,
            currentPos.y - _this.viewCoords.y,
            _this.startCoords.x - _this.viewCoords.x,
            _this.startCoords.y - _this.viewCoords.y,
          ],
          c: _this.drawcolor,
          th: _this.thickness,
          s: size,
        });
        _this.svgContainer.find("line").remove();
      } else if (_this.tool === "arrow") {
        if (_this.pressedKeys.shift) {
          currentPos = _this.getRoundedAngles(currentPos);
        }

        var width = _this._boardWidth();
        var height = _this._boardHeight();
        var size = [width, height];
        _this.drawArrow(
          size,
          currentPos.x,
          currentPos.y,
          _this.startCoords.x,
          _this.startCoords.y,
          _this.drawcolor,
          _this.thickness
        );

        _this.sendFunction({
          t: _this.tool,
          d: [
            currentPos.x - _this.viewCoords.x,
            currentPos.y - _this.viewCoords.y,
            _this.startCoords.x - _this.viewCoords.x,
            _this.startCoords.y - _this.viewCoords.y,
          ],
          c: _this.drawcolor,
          th: _this.thickness,
          s: size,
        });
        _this.svgContainer.find("line").remove();
        _this.svgContainer.find("marker").remove();
        _this.svgContainer.find("arrow").remove();
      } else if (_this.tool === "pen") {
        _this.pushPointSmoothPen(currentPos.x, currentPos.y);
      } else if (_this.tool === "triangle") {
        var screenWidth = _this._boardWidth();
        var screenHeight = _this._boardHeight();
        var size = [screenWidth, screenHeight];

        const dx = currentPos.x - _this.startCoords.x;
        const dy = currentPos.y - _this.startCoords.y;
        const dist = Math.hypot(dx, dy);
        const height = dist * Math.sin(Math.PI / 3);
        const width = (height * Math.sqrt(3)) / 2;

        _this.drawTriangle(
          size,
          _this.startCoords.x,
          _this.startCoords.y,
          _this.startCoords.x - width / 2,
          _this.startCoords.y + height,
          _this.startCoords.x + width / 2,
          _this.startCoords.y + height,
          _this.drawcolor,
          _this.thickness
        );
        _this.sendFunction({
          t: _this.tool,
          d: [
            _this.startCoords.x - _this.viewCoords.x,
            _this.startCoords.y - _this.viewCoords.y,
            _this.startCoords.x - width / 2 - _this.viewCoords.x,
            _this.startCoords.y + height - _this.viewCoords.y,
            _this.startCoords.x + width / 2 - _this.viewCoords.x,
            _this.startCoords.y + height - _this.viewCoords.y,
          ],
          c: _this.drawcolor,
          th: _this.thickness,
          s: size,
        });
        _this.svgContainer.find("polygon").remove();
      } else if (_this.tool === "rect") {
        if (_this.pressedKeys.shift) {
          if (
            (currentPos.x - _this.startCoords.x) *
              (currentPos.y - _this.startCoords.y) >
            0
          ) {
            currentPos = new Point(
              currentPos.x,
              _this.startCoords.y + (currentPos.x - _this.startCoords.x)
            );
          } else {
            currentPos = new Point(
              currentPos.x,
              _this.startCoords.y - (currentPos.x - _this.startCoords.x)
            );
          }
        }

        var width = _this._boardWidth();
        var height = _this._boardHeight();
        var size = [width, height];
        _this.drawRec(
          size,
          _this.startCoords.x,
          _this.startCoords.y,
          currentPos.x,
          currentPos.y,
          _this.drawcolor,
          _this.thickness
        );
        _this.sendFunction({
          t: _this.tool,
          d: [
            _this.startCoords.x - _this.viewCoords.x,
            _this.startCoords.y - _this.viewCoords.y,
            currentPos.x - _this.viewCoords.x,
            currentPos.y - _this.viewCoords.y,
          ],
          c: _this.drawcolor,
          th: _this.thickness,
          s: size,
        });
        _this.svgContainer.find("rect").remove();
      } else if (_this.tool === "circle") {
        // const r = currentPos.distTo(_this.startCoords);
        // var width = _this._boardWidth();
        // var height = _this._boardHeight();
        // var size = [width, height];
        // const dx = currentPos.x - _this.startCoords.x;
        // const dy = currentPos.y - _this.startCoords.y;
        // const offset = Math.sqrt(dx * dx + dy * dy);

        // _this.drawCircle(
        //   size,
        //   currentPos.x - offset,
        //   currentPos.y - offset,
        //   r,
        //   _this.drawcolor,
        //   _this.thickness
        // );
        // _this.sendFunction({
        //   t: _this.tool,
        //   d: [
        //     currentPos.x - _this.viewCoords.x - offset,
        //     currentPos.y - _this.viewCoords.y - offset,
        //     r,
        //   ],
        //   c: _this.drawcolor,
        //   th: _this.thickness,
        //   s: size,
        // });
        // _this.svgContainer.find("circle").remove();

        var width = _this._boardWidth();
        var height = _this._boardHeight();
        var size = [width, height];
        const dx = currentPos.x - _this.startCoords.x;
        const dy = currentPos.y - _this.startCoords.y;
        const rx = Math.abs(dx) / 2;
        const ry = Math.abs(dy) / 2;

        _this.drawCircle(
          size,
          _this.startCoords.x + dx / 2,
          _this.startCoords.y + dy / 2,
          rx,
          ry,
          _this.drawcolor,
          _this.thickness
        );
        _this.sendFunction({
          t: _this.tool,
          d: [
            _this.startCoords.x + dx / 2 - _this.viewCoords.x,
            _this.startCoords.y + dy / 2 - _this.viewCoords.y,
            rx,
            ry,
          ],
          c: _this.drawcolor,
          th: _this.thickness,
          s: size,
        });
        _this.svgContainer.find("ellipse").remove();
      } else if (_this.tool === "ellipse") {
        var width = _this._boardWidth();
        var height = _this._boardHeight();
        var size = [width, height];
        const dx = currentPos.x - _this.startCoords.x;
        const dy = currentPos.y - _this.startCoords.y;
        // const rx = Math.abs(dx);
        // const ry = Math.abs(dy);

        // const horizontalDirection = dx >= 0 ? 1 : -1;
        // const offsetX = horizontalDirection * rx;
        // const offsetY = ry;

        // _this.drawEllipse(
        //   size,
        //   currentPos.x - offsetX,
        //   currentPos.y - offsetY,
        //   rx,
        //   ry,
        //   _this.drawcolor,
        //   _this.thickness
        // );
        // _this.sendFunction({
        //   t: _this.tool,
        //   d: [
        //     currentPos.x - _this.viewCoords.x - offsetX,
        //     currentPos.y - _this.viewCoords.y - offsetY,
        //     rx,
        //     ry,
        //   ],
        //   c: _this.drawcolor,
        //   th: _this.thickness,
        //   s: size,
        // });

        const rx = Math.abs(dx) / 2;
        const ry = Math.abs(dy) / 2;

        _this.drawEllipse(
          size,
          _this.startCoords.x + dx / 2,
          _this.startCoords.y + dy / 2,
          rx,
          ry,
          _this.drawcolor,
          _this.thickness
        );
        _this.sendFunction({
          t: _this.tool,
          d: [
            _this.startCoords.x + dx / 2 - _this.viewCoords.x,
            _this.startCoords.x + dx / 2 - _this.viewCoords.y,
            rx,
            ry,
          ],
          c: _this.drawcolor,
          th: _this.thickness,
          s: size,
        });
        _this.svgContainer.find("ellipse").remove();
      } else if (_this.tool === "recSelect") {
        _this.imgDragActive = true;
        if (_this.pressedKeys.shift) {
          if (
            (currentPos.x - _this.startCoords.x) *
              (currentPos.y - _this.startCoords.y) >
            0
          ) {
            currentPos = new Point(
              currentPos.x,
              _this.startCoords.y + (currentPos.x - _this.startCoords.x)
            );
          } else {
            currentPos = new Point(
              currentPos.x,
              _this.startCoords.y - (currentPos.x - _this.startCoords.x)
            );
          }
        }

        const width = Math.abs(_this.startCoords.x - currentPos.x);
        const height = Math.abs(_this.startCoords.y - currentPos.y);
        const left =
          _this.startCoords.x < currentPos.x
            ? _this.startCoords.x
            : currentPos.x;
        const top =
          _this.startCoords.y < currentPos.y
            ? _this.startCoords.y
            : currentPos.y;
        _this.mouseOverlay.css({ cursor: "default" });
        const imgDiv = $(
          `<div class="dragMe" style="position:absolute; left: ${left}px; top: ${top}px; width: ${width}px; border: 2px dotted gray; overflow: hidden; height: ${height}px; background: rgba(173, 216, 230, 0.25);" cursor:move;">
                    <canvas style="cursor:move; position:absolute; top:0px; left:0px;" width="${width}" height="${height}"></canvas>
                    <div style="position:absolute; right:5px; top:3px;">
                    <button draw="1" style="margin: 0px 0px; background: #03a9f4; padding: 5px; margin-top: 3px; color: white;" class="addToCanvasBtn btn btn-default">Drop</button>
                    <button style="margin: 0px 0px; background: #03a9f4; padding: 5px; margin-top: 3px; color: white;" class="xCanvasBtn btn btn-default">x</button>
                    </div>
                    </div>`
        );
        const dragCanvas = $(imgDiv).find("canvas");
        const dragOutOverlay = $(
          `<div class="dragOutOverlay" style="position:absolute; left: ${left}px; top: ${top}px; width: ${width}px; height: ${height}px; background:rgba(173, 216, 230, 0.25);;"></div>`
        );
        _this.mouseOverlay.append(dragOutOverlay);
        _this.mouseOverlay.append(imgDiv);

        const destCanvasContext = dragCanvas[0].getContext("2d");
        destCanvasContext.drawImage(
          _this.canvas,
          left,
          top,
          width,
          height,
          0,
          0,
          width,
          height
        );
        imgDiv
          .find(".xCanvasBtn")
          .off("click")
          .click(function () {
            _this.imgDragActive = false;
            _this.refreshCursorAppearance();
            imgDiv.remove();
            dragOutOverlay.remove();
          });
        imgDiv
          .find(".addToCanvasBtn")
          .off("click")
          .click(function () {
            _this.imgDragActive = false;
            _this.refreshCursorAppearance();
            const p = imgDiv.position();
            const leftT = Math.round(p.left * 100) / 100;
            const topT = Math.round(p.top * 100) / 100;
            _this.drawId++;
            _this.sendFunction({
              t: _this.tool,
              d: [
                left - _this.viewCoords.x, //left from
                top - _this.viewCoords.y,
                leftT - _this.viewCoords.x, //Left too
                topT - _this.viewCoords.y,
                width,
                height,
              ],
            });

            _this.dragCanvasRectContent(left, top, leftT, topT, width, height);
            imgDiv.remove();
            dragOutOverlay.remove();
          });
        imgDiv.draggable();
        _this.svgContainer.find("rect").remove();
      }
      _this.drawId++;
    };

    _this.mouseOverlay.on("mouseout", function (e) {
      if (ReadOnlyService.readOnlyActive) return;
      _this.triggerMouseOut();
    });

    _this.mouseOverlay.on("mouseover", function (e) {
      if (ReadOnlyService.readOnlyActive) return;
      _this.triggerMouseOver();
    });

    // On text container click (Add a new textbox)
    _this.textContainer.on("click", function (e) {
      const currentPos = Point.fromEvent(e);
      const fontsize = _this.thickness * 0.5;
      const txId = "tx" + +new Date();
      const isStickyNote = _this.tool === "stickynote";
      var width = _this._boardWidth();
      var height = _this._boardHeight();
      var size = [width, height];
      var cursorHeightOffset = _this.getCursorHeight(fontsize) + 5;

      _this.sendFunction({
        t: "addTextBox",
        d: [
          _this.drawcolor,
          _this.textboxBackgroundColor,
          fontsize,
          currentPos.x - _this.viewCoords.x,
          currentPos.y - _this.viewCoords.y - cursorHeightOffset,
          txId,
          isStickyNote,
          _this.settings.username,
        ],
        s: size,
      });
      _this.addTextBox(
        size,
        _this.drawcolor,
        _this.textboxBackgroundColor,
        fontsize,
        currentPos.x - _this.viewCoords.x,
        currentPos.y - _this.viewCoords.y - cursorHeightOffset,
        txId,
        isStickyNote,
        _this.settings.username,
        true
      );
    });
  },
  /**
   * For drawing lines at 0,45,90° ....
   * @param {Point} currentPos
   * @returns {Point}
   */
  getRoundedAngles: function (currentPos) {
    const { startCoords } = this;

    // these transformations operate in the standard coordinate system
    // y goes from bottom to up, x goes left to right
    const dx = currentPos.x - startCoords.x; // browser x is reversed
    const dy = startCoords.y - currentPos.y;

    const angle = Math.atan2(dy, dx);
    const angle45 = Math.round(angle / _45_DEG_IN_RAD) * _45_DEG_IN_RAD;

    const dist = currentPos.distTo(startCoords);
    let outX = startCoords.x + dist * Math.cos(angle45);
    let outY = startCoords.y - dist * Math.sin(angle45);

    return new Point(outX, outY);
  },
  triggerMouseMove: function (e) {
    const _this = this;
    if (_this.imgDragActive) {
      return;
    }

    // 始终保存最新事件，供 pending rAF 使用
    _this._pendingMoveEvent = e;
    let currentPos = Point.fromEvent(e);

    // 节流：已有 pending rAF 时跳过注册，避免大量 rAF 排队导致 CPU 飙升和闪烁
    if (!_this._mouseMoveRAFPending) {
      _this._mouseMoveRAFPending = true;
    window.requestAnimationFrame(function () {
      _this._mouseMoveRAFPending = false;
      // 使用最新保存的事件（而非注册时的旧事件）
      currentPos = Point.fromEvent(_this._pendingMoveEvent);

      if (_this.drawFlag) {
        if (_this.tool === "pen") {
          _this.pushPointSmoothPen(currentPos.x, currentPos.y);
        } else if (_this.tool === "eraser") {
          var width = _this._boardWidth();
          var height = _this._boardHeight();
          var size = [width, height];

          _this.drawEraserLine(
            size,
            currentPos.x,
            currentPos.y,
            _this.prevPos.x,
            _this.prevPos.y,
            _this.thickness
          );
          _this.sendFunction({
            t: _this.tool,
            d: [
              currentPos.x - _this.viewCoords.x,
              currentPos.y - _this.viewCoords.y,
              _this.prevPos.x - _this.viewCoords.x,
              _this.prevPos.y - _this.viewCoords.y,
            ],
            th: _this.thickness,
            s: size,
          });
        }
      }

      if (_this.tool === "eraser") {
        const left = currentPos.x - _this.thickness;
        const top = currentPos.y - _this.thickness;
        if (_this.ownCursor)
          _this.ownCursor.css({ top: top + "px", left: left + "px" });
      } else if (_this.tool === "pen") {
        const left = currentPos.x - _this.thickness / 2;
        const top = currentPos.y - _this.thickness / 2;
        if (_this.ownCursor)
          _this.ownCursor.css({ top: top + "px", left: left + "px" });
      } else if (_this.tool === "line") {
        if (_this.svgLine) {
          let posToUse = currentPos;
          if (_this.pressedKeys.shift) {
            posToUse = _this.getRoundedAngles(currentPos);
          }
          _this.svgLine.setAttribute("x2", posToUse.x);
          _this.svgLine.setAttribute("y2", posToUse.y);
        }
      } else if (_this.tool === "arrow") {
        if (_this.svgArrow) {
          let posToUse = currentPos;
          if (_this.pressedKeys.shift) {
            posToUse = _this.getRoundedAngles(currentPos);
          }
          _this.svgArrow.setAttribute("x2", posToUse.x);
          _this.svgArrow.setAttribute("y2", posToUse.y);
        }
      } else if (
        _this.tool === "rect" ||
        (_this.tool === "recSelect" && _this.drawFlag)
      ) {
        if (_this.svgRect) {
          const width = Math.abs(currentPos.x - _this.startCoords.x);
          let height = Math.abs(currentPos.y - _this.startCoords.y);
          if (_this.pressedKeys.shift) {
            height = width;
            const x =
              currentPos.x < _this.startCoords.x
                ? _this.startCoords.x - width
                : _this.startCoords.x;
            const y =
              currentPos.y < _this.startCoords.y
                ? _this.startCoords.y - width
                : _this.startCoords.y;
            _this.svgRect.setAttribute("x", x);
            _this.svgRect.setAttribute("y", y);
          } else {
            const x =
              currentPos.x < _this.startCoords.x
                ? currentPos.x
                : _this.startCoords.x;
            const y =
              currentPos.y < _this.startCoords.y
                ? currentPos.y
                : _this.startCoords.y;
            _this.svgRect.setAttribute("x", x);
            _this.svgRect.setAttribute("y", y);
          }

          _this.svgRect.setAttribute("width", width);
          _this.svgRect.setAttribute("height", height);
        }
      } else if (_this.tool === "triangle") {
        // if (_this.svgTriangle) {
        //   const points = `${_this.startCoords.x},${_this.startCoords.y} ${currentPos.x},${_this.startCoords.y} ${currentPos.x},${currentPos.y}`;
        //   _this.svgTriangle.setAttribute("points", points);
        // }
        if (_this.svgTriangle) {
          const dx = currentPos.x - _this.startCoords.x;
          const dy = currentPos.y - _this.startCoords.y;
          const dist = Math.hypot(dx, dy);
          const height = dist * Math.sin(Math.PI / 3);
          const width = (height * Math.sqrt(3)) / 2;

          const p1 = `${_this.startCoords.x},${_this.startCoords.y}`;
          const p2 = `${_this.startCoords.x - width / 2},${
            _this.startCoords.y + height
          }`;
          const p3 = `${_this.startCoords.x + width / 2},${
            _this.startCoords.y + height
          }`;

          _this.svgTriangle.setAttribute("points", `${p1} ${p2} ${p3}`);
        }
      } else if (_this.tool === "circle") {
        // const r = currentPos.distTo(_this.startCoords);
        // if (_this.svgCirle) {
        //   const dx = currentPos.x - _this.startCoords.x;
        //   const dy = currentPos.y - _this.startCoords.y;
        //   const radius = Math.min(dx, dy) / 2;
        //   const centerX = _this.startCoords.x + dx / 2;
        //   const centerY = _this.startCoords.y + dy / 2;
        //   const angle = Math.atan2(dy, dx) * (180 / Math.PI);

        //   if (angle >= 0 && angle <= 90) {
        //     console.error(_this.startCoords, centerX, centerY, radius);
        //     if (
        //       centerX - radius == _this.startCoords.x &&
        //       centerY - radius == _this.startCoords.y
        //     ) {
        //       _this.svgCirle.setAttribute("cx", centerX);
        //       _this.svgCirle.setAttribute("cy", centerY);
        //       _this.svgCirle.setAttribute("r", radius);
        //     } else {
        //       _this.svgCirle.setAttribute("r", radius);
        //     }
        //   }
        // }
        if (_this.svgCirle) {
          const dx = currentPos.x - _this.startCoords.x;
          const dy = currentPos.y - _this.startCoords.y;
          const rx = Math.abs(dx) / 2;
          const ry = Math.abs(dy) / 2;

          _this.svgCirle.setAttribute("cx", _this.startCoords.x + dx / 2);
          _this.svgCirle.setAttribute("cy", _this.startCoords.y + dy / 2);
          _this.svgCirle.setAttribute("rx", rx);
          _this.svgCirle.setAttribute("ry", ry);
        }
      } else if (_this.tool === "ellipse") {
        if (_this.svgEllipse) {
          const dx = currentPos.x - _this.startCoords.x;
          const dy = currentPos.y - _this.startCoords.y;
          const rx = Math.abs(dx) / 2;
          const ry = Math.abs(dy) / 2;

          _this.svgEllipse.setAttribute("cx", _this.startCoords.x + dx / 2);
          _this.svgEllipse.setAttribute("cy", _this.startCoords.y + dy / 2);
          _this.svgEllipse.setAttribute("rx", rx);
          _this.svgEllipse.setAttribute("ry", ry);

          // const rx = Math.abs(dx);
          // const ry = Math.abs(dy);

          // const horizontalDirection = dx >= 0 ? 1 : -1;
          // const offsetX = horizontalDirection * rx;
          // const offsetY = ry;

          // _this.svgEllipse.setAttribute("cx", currentPos.x - offsetX);
          // _this.svgEllipse.setAttribute("cy", currentPos.y - offsetY);
          // _this.svgEllipse.setAttribute("rx", rx);
          // _this.svgEllipse.setAttribute("ry", ry);
        }
      }

      _this.prevPos = currentPos;
    });
    } // end if !_this._mouseMoveRAFPending

    ThrottlingService.throttle(currentPos, () => {
      currentPos.x -= _this.viewCoords.x;
      currentPos.y -= _this.viewCoords.y;
      var width = _this._boardWidth();
      var height = _this._boardHeight();

      _this.lastPointerPosition = currentPos;
      _this.sendFunction({
        t: "cursor",
        event: "move",
        d: [currentPos.x, currentPos.y, width, height],
        username: _this.settings.username,
      });
    });
  },
  triggerMouseOver: function () {
    var _this = this;
    if (_this.imgDragActive) {
      return;
    }
    if (!_this.mouseover) {
      var color = _this.drawcolor;
      var widthHeight = _this.thickness;
      if (_this.tool === "eraser") {
        color = "#00000000";
        widthHeight = widthHeight * 2;
      }
      if (_this.tool === "eraser" || _this.tool === "pen") {
        _this.ownCursor = $(
          '<div id="ownCursor" style="background:' +
            color +
            "; border:1px solid gray; position:absolute; width:" +
            widthHeight +
            "px; height:" +
            widthHeight +
            'px; border-radius:50%;"></div>'
        );
        _this.cursorContainer.append(_this.ownCursor);
      }
    }
    _this.mouseover = true;
  },
  triggerMouseOut: function () {
    var _this = this;
    if (_this.imgDragActive) {
      return;
    }
    _this.drawFlag = false;
    _this.mouseover = false;
    _this.ctx.globalCompositeOperation = _this.oldGCO;
    if (_this.ownCursor) _this.ownCursor.remove();
    _this.svgContainer.find("line").remove();
    _this.svgContainer.find("marker").remove();
    _this.svgContainer.find("arrow").remove();
    _this.svgContainer.find("rect").remove();
    _this.svgContainer.find("triangle").remove();
    _this.svgContainer.find("circle").remove();
    _this.svgContainer.find("ellipse").remove();
    _this.sendFunction({ t: "cursor", event: "out" });
  },
  redrawMouseCursor: function () {
    const _this = this;
    _this.triggerMouseOut();
    _this.triggerMouseOver();
    _this.triggerMouseMove({
      offsetX: _this.prevPos.x,
      offsetY: _this.prevPos.y,
    });
  },
  delKeyAction: function () {
    var _this = this;
    $.each(_this.mouseOverlay.find(".dragOutOverlay"), function () {
      var width = $(this).width();
      var height = $(this).height();
      var p = $(this).position();
      var left = Math.round(p.left * 100) / 100;
      var top = Math.round(p.top * 100) / 100;
      _this.drawId++;
      _this.sendFunction({
        t: "eraseRec",
        d: [left - _this.viewCoords.x, top - _this.viewCoords.y, width, height],
      });

      _this.eraseRec(left, top, width, height);
    });
    _this.mouseOverlay.find(".xCanvasBtn").click(); //Remove all current drops
    _this.textContainer
      .find("#" + _this.latestActiveTextBoxId)
      .find(".removeIcon")
      .click();
  },
  escKeyAction: function () {
    var _this = this;
    if (!_this.drawFlag) {
      _this.svgContainer.empty();
    }
    _this.mouseOverlay.find(".xCanvasBtn").click(); //Remove all current drops
  },
  pushPointSmoothPen: function (X, Y) {
    var _this = this;
    var width = _this._boardWidth();
    var height = _this._boardHeight();
    if (_this.penSmoothLastCoords.length >= 8) {
      _this.penSmoothLastCoords = [
        _this.penSmoothLastCoords[2],
        _this.penSmoothLastCoords[3],
        _this.penSmoothLastCoords[4],
        _this.penSmoothLastCoords[5],
        _this.penSmoothLastCoords[6],
        _this.penSmoothLastCoords[7],
      ];
    }
    _this.penSmoothLastCoords.push(X, Y, width, height);
    // console.log("drawpen", _this.penSmoothLastCoords);
    if (_this.penSmoothLastCoords.length >= 8) {
      _this.drawPenSmoothLine(
        _this.penSmoothLastCoords,
        _this.drawcolor,
        _this.thickness
      );
      let sendArray = [];
      for (let i = 0; i < _this.penSmoothLastCoords.length; i++) {
        sendArray.push(_this.penSmoothLastCoords[i]);
        if (i % 2 == 0) {
          sendArray[i] -= this.viewCoords.x;
        } else {
          sendArray[i] -= this.viewCoords.y;
        }
      }

      _this.sendFunction({
        t: _this.tool,
        d: sendArray,
        c: _this.drawcolor,
        th: _this.thickness,
      });
    }
  },
  dragCanvasRectContent: function (xf, yf, xt, yt, width, height, remote) {
    var _this = this;
    let xOffset = remote ? _this.viewCoords.x : 0;
    let yOffset = remote ? _this.viewCoords.y : 0;
    var tempCanvas = document.createElement("canvas");
    tempCanvas.width = width;
    tempCanvas.height = height;
    var tempCanvasContext = tempCanvas.getContext("2d");
    tempCanvasContext.drawImage(
      this.canvas,
      xf + xOffset,
      yf + yOffset,
      width,
      height,
      0,
      0,
      width,
      height
    );
    this.eraseRec(xf + xOffset, yf + yOffset, width, height);
    this.ctx.drawImage(tempCanvas, xt + xOffset, yt + yOffset);
  },
  dragCanvasObjContent: function (
    xf,
    yf,
    xt,
    yt,
    width,
    height,
    remote,
    canvas,
    size,
    oldCoor
  ) {
    var _this = this;
    let xOffset = remote ? _this.viewCoords.x : 0;
    let yOffset = remote ? _this.viewCoords.y : 0;
    var tempCanvas = document.createElement("canvas");
    var width = _this._boardWidth();
    var height = _this._boardHeight();
    tempCanvas.width = width;
    tempCanvas.height = height;
    let [left, top, leftT, topT, wObj, hObj] = [
      xf + xOffset,
      yf + yOffset,
      xt + xOffset,
      yt + yOffset,
      width,
      height,
    ];

    if (remote) {
      const scaleX = width / size[0];
      const scaleY = height / size[1];
      left *= scaleX;
      top *= scaleY;
      leftT *= scaleX;
      topT *= scaleY;

      oldCoor[0] *= scaleX;
      oldCoor[1] *= scaleY;
      oldCoor[2] *= scaleX;
      oldCoor[3] *= scaleY;
    }

    var tempCanvasContext = tempCanvas.getContext("2d");
    tempCanvasContext.drawImage(
      canvas,
      left,
      top,
      wObj,
      hObj,
      0,
      0,
      wObj,
      hObj
    );

    this.eraseRec(oldCoor[0], oldCoor[1], oldCoor[2], oldCoor[3], remote);
    this.ctx.drawImage(tempCanvas, leftT, topT);
  },
  eraseRec: function (fromX, fromY, width, height, remote, drawId) {
    var _this = this;
    let xOffset = remote ? _this.viewCoords.x : 0;
    let yOffset = remote ? _this.viewCoords.y : 0;

    if (!_this.eraseHistory[drawId]) {
      _this.eraseHistory[drawId] = {
        fromX: fromX + xOffset,
        fromY: fromY + yOffset,
        width: width,
        height: height,
        imageData: _this.ctx.getImageData(
          fromX + xOffset,
          fromY + yOffset,
          width,
          height
        ),
      };
    }

    _this.ctx.beginPath();
    _this.ctx.rect(fromX + xOffset, fromY + yOffset, width, height);
    _this.ctx.globalCompositeOperation = "destination-out";
    _this.ctx.fillStyle = "rgba(0, 0, 0, 1)";
    _this.ctx.fill();
    _this.ctx.closePath();
    _this.ctx.globalCompositeOperation = _this.oldGCO;
  },
  cancelEraseRec: function (id) {
    var _this = this;
    Object.entries(_this.eraseHistory).forEach(([drawId, data]) => {
      if (drawId == id) {
        _this.ctx.putImageData(data.imageData, data.fromX, data.fromY);
        delete _this.eraseHistory[drawId];
      }
    });
  },

  drawPenLine: function (
    size,
    fromX,
    fromY,
    toX,
    toY,
    color,
    thickness,
    remote
  ) {
    var _this = this;
    _this.ctx.beginPath();
    let xOffset = remote ? _this.viewCoords.x : 0;
    let yOffset = remote ? _this.viewCoords.y : 0;
    if (remote) {
      var width = _this._boardWidth();
      var height = _this._boardHeight();
      const scaleX = width / size[0];
      const scaleY = height / size[1];
      fromX = fromX * scaleX;
      fromY = fromY * scaleY;
      toX = toX * scaleX;
      toY = toY * scaleY;
      const scale = Math.min(scaleX, scaleY);
      thickness = thickness * scale;
    }

    _this.ctx.moveTo(fromX + xOffset, fromY + yOffset);
    _this.ctx.lineTo(toX + xOffset, toY + yOffset);
    _this.ctx.strokeStyle = color;
    _this.ctx.lineWidth = thickness;
    _this.ctx.lineCap = _this.lineCap;
    _this.ctx.stroke();
    _this.ctx.closePath();
  },
  drawPenSmoothLine: function (coords, color, thickness, remote) {
    var _this = this;
    var width = _this._boardWidth();
    var height = _this._boardHeight();
    var xm1 = coords[0];
    var ym1 = coords[1];
    var x0 = coords[2];
    var y0 = coords[3];
    var x1 = coords[4];
    var y1 = coords[5];
    var x2 = coords[6];
    var y2 = coords[7];

    if (remote) {
      const scaleX = width / coords[8];
      const scaleY = height / coords[9];
      xm1 = xm1 * scaleX;
      ym1 = ym1 * scaleY;
      x0 = x0 * scaleX;
      y0 = y0 * scaleY;
      x1 = x1 * scaleX;
      y1 = y1 * scaleY;
      x2 = x2 * scaleX;
      y2 = y2 * scaleY;
      thickness = thickness * Math.min(scaleX, scaleY);
    }

    var length = Math.sqrt(Math.pow(x0 - x1, 2) + Math.pow(y0 - y1, 2));
    var steps = Math.ceil(length / 5);
    _this.ctx.beginPath();
    let xOffset = remote ? _this.viewCoords.x : 0;
    let yOffset = remote ? _this.viewCoords.y : 0;
    _this.ctx.moveTo(x0 + xOffset, y0 + yOffset);
    if (steps == 0) {
      _this.ctx.lineTo(x0 + xOffset, y0 + yOffset);
    }
    for (var i = 0; i < steps; i++) {
      var point = lanczosInterpolate(
        xm1,
        ym1,
        x0,
        y0,
        x1,
        y1,
        x2,
        y2,
        (i + 1) / steps
      );
      _this.ctx.lineTo(point[0] + xOffset, point[1] + yOffset);
    }
    _this.ctx.strokeStyle = color;
    _this.ctx.lineWidth = thickness;
    _this.ctx.lineCap = _this.lineCap;
    _this.ctx.stroke();
    _this.ctx.closePath();
  },
  drawEraserLine: function (size, fromX, fromY, toX, toY, thickness, remote) {
    var _this = this;
    let xOffset = remote ? _this.viewCoords.x : 0;
    let yOffset = remote ? _this.viewCoords.y : 0;
    if (remote) {
      var width = _this._boardWidth();
      var height = _this._boardHeight();
      const scaleX = width / size[0];
      const scaleY = height / size[1];
      fromX = fromX * scaleX;
      fromY = fromY * scaleY;
      toX = toX * scaleX;
      toY = toY * scaleY;
      const scale = Math.min(scaleX, scaleY);
      thickness = thickness * scale;
    }
    _this.ctx.beginPath();
    _this.ctx.moveTo(fromX + xOffset, fromY + yOffset);
    _this.ctx.lineTo(toX + xOffset, toY + yOffset);
    _this.ctx.strokeStyle = "rgba(0,0,0,1)";
    _this.ctx.lineWidth = thickness * 2;
    _this.ctx.lineCap = _this.lineCap;
    _this.ctx.globalCompositeOperation = "destination-out";
    _this.ctx.stroke();
    _this.ctx.closePath();
    _this.ctx.globalCompositeOperation = _this.oldGCO;
  },
  drawRec: function (size, fromX, fromY, toX, toY, color, thickness, remote) {
    var _this = this;
    let xOffset = remote ? _this.viewCoords.x : 0;
    let yOffset = remote ? _this.viewCoords.y : 0;
    if (remote) {
      var width = _this._boardWidth();
      var height = _this._boardHeight();
      const scaleX = width / size[0];
      const scaleY = height / size[1];
      fromX = fromX * scaleX;
      fromY = fromY * scaleY;
      toX = toX * scaleX;
      toY = toY * scaleY;
      const scale = Math.min(scaleX, scaleY);
      thickness = thickness * scale;
    }

    toX = toX - fromX - xOffset;
    toY = toY - fromY - yOffset;
    _this.ctx.beginPath();
    _this.ctx.rect(
      fromX + xOffset,
      fromY + yOffset,
      toX + xOffset,
      toY + yOffset
    );
    _this.ctx.strokeStyle = color;
    _this.ctx.lineWidth = thickness;
    _this.ctx.lineCap = _this.lineCap;
    _this.ctx.stroke();
    _this.ctx.closePath();
  },
  drawTriangle: function (
    size,
    x1,
    y1,
    x2,
    y2,
    x3,
    y3,
    color,
    thickness,
    remote
  ) {
    var _this = this;
    let xOffset = remote ? _this.viewCoords.x : 0;
    let yOffset = remote ? _this.viewCoords.y : 0;
    if (remote) {
      var width = _this._boardWidth();
      var height = _this._boardHeight();
      const scaleX = width / size[0];
      const scaleY = height / size[1];
      x1 = x1 * scaleX;
      y1 = y1 * scaleY;
      x2 = x2 * scaleX;
      y2 = y2 * scaleY;
      x3 = x3 * scaleX;
      y3 = y3 * scaleY;
      const scale = Math.min(scaleX, scaleY);
      thickness = thickness * scale;
    }

    _this.ctx.beginPath();
    _this.ctx.moveTo(x1 + xOffset, y1 + yOffset);
    _this.ctx.lineTo(x2 + xOffset, y2 + yOffset);
    _this.ctx.lineTo(x3 + xOffset, y3 + yOffset);
    _this.ctx.closePath();

    _this.ctx.lineWidth = thickness;
    _this.ctx.strokeStyle = color;
    _this.ctx.stroke();
  },
  // drawCircle: function (size, fromX, fromY, radius, color, thickness, remote) {
  //   var _this = this;
  //   let xOffset = remote ? _this.viewCoords.x : 0;
  //   let yOffset = remote ? _this.viewCoords.y : 0;
  //   if (remote) {
  //     var width = _this._boardWidth();
  //     var height = _this._boardHeight();
  //     const scaleX = width / size[0];
  //     const scaleY = width / size[0];
  //     fromX = fromX * scaleX;
  //     fromY = fromY * scaleY;
  //     const scale = Math.min(scaleX, scaleY);
  //     thickness = thickness * scale;
  //     radius = radius * scaleX;
  //   }
  //   _this.ctx.beginPath();
  //   _this.ctx.arc(
  //     fromX + xOffset,
  //     fromY + yOffset,
  //     radius,
  //     0,
  //     2 * Math.PI,
  //     false
  //   );
  //   _this.ctx.lineWidth = thickness;
  //   _this.ctx.strokeStyle = color;
  //   _this.ctx.stroke();
  // },
  drawCircle: function (
    size,
    fromX,
    fromY,
    radiusX,
    radiusY,
    color,
    thickness,
    remote
  ) {
    var _this = this;
    let xOffset = remote ? _this.viewCoords.x : 0;
    let yOffset = remote ? _this.viewCoords.y : 0;
    if (remote) {
      var width = _this._boardWidth();
      var height = _this._boardHeight();
      const scaleX = width / size[0];
      const scaleY = height / size[1];
      fromX = fromX * scaleX;
      fromY = fromY * scaleY;
      const scale = Math.min(scaleX, scaleY);
      thickness = thickness * scale;
      radiusX = radiusX * scaleX;
      radiusY = radiusY * scaleX;
    }
    _this.ctx.beginPath();
    _this.ctx.ellipse(
      fromX + xOffset,
      fromY + yOffset,
      radiusX,
      radiusY,
      0,
      0,
      2 * Math.PI,
      false
    );
    _this.ctx.lineWidth = thickness;
    _this.ctx.strokeStyle = color;
    _this.ctx.stroke();
  },
  drawEllipse: function (
    size,
    fromX,
    fromY,
    radiusX,
    radiusY,
    color,
    thickness,
    remote
  ) {
    var _this = this;
    let xOffset = remote ? _this.viewCoords.x : 0;
    let yOffset = remote ? _this.viewCoords.y : 0;
    if (remote) {
      var width = _this._boardWidth();
      var height = _this._boardHeight();
      const scaleX = width / size[0];
      const scaleY = height / size[1];
      fromX = fromX * scaleX;
      fromY = fromY * scaleY;
      const scale = Math.min(scaleX, scaleY);
      thickness = thickness * scale;
      radiusX = radiusX * scaleX;
      radiusY = radiusY * scaleX;
    }
    _this.ctx.beginPath();
    _this.ctx.ellipse(
      fromX + xOffset,
      fromY + yOffset,
      radiusX,
      radiusY,
      0,
      0,
      2 * Math.PI,
      false
    );
    _this.ctx.lineWidth = thickness;
    _this.ctx.strokeStyle = color;
    _this.ctx.stroke();
  },
  drawArrow: function (size, fromX, fromY, toX, toY, color, thickness, remote) {
    var _this = this;

    if (remote) {
      var width = _this._boardWidth();
      var height = _this._boardHeight();
      const scaleX = width / size[0];
      const scaleY = height / size[1];
      fromX = fromX * scaleX;
      fromY = fromY * scaleY;
      toX = toX * scaleX;
      toY = toY * scaleY;
      thickness = thickness * Math.min(scaleX, scaleY);
    }

    let xOffset = remote ? _this.viewCoords.x : 0;
    let yOffset = remote ? _this.viewCoords.y : 0;

    const angle = Math.atan2(fromY - toY, fromX - toX);
    const arrowSize = thickness * 3;

    const startX = toX;
    const startY = toY;
    const endX = fromX;
    const endY = fromY;

    // Draw the line
    _this.ctx.beginPath();
    _this.ctx.moveTo(startX + xOffset, startY + yOffset);
    _this.ctx.lineTo(endX + xOffset, endY + yOffset);
    _this.ctx.lineWidth = thickness;
    _this.ctx.strokeStyle = color;
    _this.ctx.stroke();

    // Draw the arrowhead
    _this.ctx.beginPath();
    _this.ctx.moveTo(
      endX - arrowSize * Math.cos(angle - Math.PI / 4) + xOffset,
      endY - arrowSize * Math.sin(angle - Math.PI / 4) + yOffset
    );
    _this.ctx.lineTo(endX + xOffset, endY + yOffset);
    _this.ctx.lineTo(
      endX - arrowSize * Math.cos(angle + Math.PI / 4) + xOffset,
      endY - arrowSize * Math.sin(angle + Math.PI / 4) + yOffset
    );
    _this.ctx.lineWidth = thickness;
    _this.ctx.strokeStyle = color;
    _this.ctx.stroke();
  },
  clearWhiteboard: function (callback) {
    var _this = this;
    console.log("clearwhiteboard");
    if (ReadOnlyService.readOnlyActive) {
      if (callback) callback();
      return;
    }
    _this.canvas.height = _this.canvas.height;
    _this.imgContainer.empty();
    _this.textContainer.empty();
    _this.sendFunction({ t: "clear" });
    _this.drawBuffer = [];
    _this.pendingBuffer = [];
    _this.undoBuffer = [];
    _this.drawId = 0;

    if (callback) callback();
  },
  clearDrawing: function () {
    var _this = this;
    if (ReadOnlyService.readOnlyActive) return;
    _this.canvas.height = _this.canvas.height;
    _this.textContainer.empty();
    _this.sendFunction({ t: "clearDrawing" });
    _this.drawBuffer = [];
    _this.undoBuffer = [];
    _this.drawId = 0;
  },
  clearSelfWhiteboard: function (callback) {
    var _this = this;
    console.log("clearwhiteboard");
    if (ReadOnlyService.readOnlyActive) {
      if (callback) callback();
      return;
    }
    _this.canvas.height = _this.canvas.height;
    _this.imgContainer.empty();
    _this.textContainer.empty();
    _this.drawBuffer = [];
    _this.undoBuffer = [];
    _this.drawId = 0;

    if (callback) callback();
  },
  setStrokeThickness(thickness) {
    var _this = this;
    _this.thickness = thickness;

    if (
      (_this.tool == "text" || this.tool === "stickynote") &&
      _this.latestActiveTextBoxId
    ) {
      _this.sendFunction({
        t: "setTextboxFontSize",
        d: [_this.latestActiveTextBoxId, thickness],
      });
      _this.setTextboxFontSize(_this.latestActiveTextBoxId, thickness);
    }
  },
  setCanvasSize(width, height) {
    var _this = this;
    const dbCp = JSON.parse(JSON.stringify(_this.drawBuffer)); // Copy the buffer
    $("#whiteboardInner").css({ width: width + "px", height: height + "px" });
    _this.canvas.width = width;
    _this.canvas.height = height;

    _this.drawBuffer = [];
    _this.textContainer.empty();
    _this.loadData(dbCp);
  },
  getCursorHeight(fontsize) {
    const tempCursor = document.createElement("span");
    tempCursor.style.fontSize = `${fontsize}px`;
    tempCursor.style.visibility = "hidden";
    tempCursor.innerText = "|";
    document.body.append(tempCursor);
    const cursorHeight = tempCursor.offsetHeight;
    document.body.removeChild(tempCursor);
    return cursorHeight;
  },
  imgWithSrc(url) {
    return $(
      DOMPurify.sanitize(
        '<img crossorigin="*" src="' + url + '" loading="lazy">',
        {
          ALLOWED_TAGS: ["img"],
          ALLOWED_ATTR: ["src", "crossorigin"], // kill any attributes mal       icious url introduced
        }
      )
    );
  },

  imgWithSrcAndId(url, id) {
    return $(
      DOMPurify.sanitize(
        '<img id="' +
          id +
          '" src="' +
          url +
          '">',
        {
          ALLOWED_TAGS: ["img"],
          ALLOWED_ATTR: ["src", "id"],
        }
      )
    );
  },

  addImgToCanvasByUrl: function (url) {
    var _this = this;
    var oldTool = _this.tool;
    var finalURL = url;
    var img = this.imgWithSrc(finalURL).css({ width: "100%", height: "100%" });
    finalURL = img.attr("src");

    // alert(finalURL);

    try {
      _this.setTool("mouse"); //Set to mouse tool while dropping to prevent errors
      _this.imgDragActive = true;
      _this.mouseOverlay.css({ cursor: "default" });
      var imgDiv = $(
        '<div class="dragMe" style="border: 2px dashed gray; position:absolute; left:200px; top:200px; min-width:160px; min-height:100px; cursor:move;z-index: 1;">' +
          '<div style="position:absolute; right:5px; top:3px;pointer-events: auto;z-index: 999;">' +
          '<button draw="1" style="margin: 0px 0px; background: #03a9f4; padding: 5px; margin-top: 3px; color: white;pointer-events: auto;touch-action: manipulation;" class="addToCanvasBtn btn btn-default">Draw to canvas</button> ' +
          '<button draw="0" style="margin: 0px 0px; background: #03a9f4; padding: 5px; margin-top: 3px; color: white;pointer-events: auto;touch-action: manipulation;" class="addToBackgroundBtn btn btn-default">Add to background</button> ' +
          '<button style="margin: 0px 0px; background: #03a9f4; padding: 5px; margin-top: 3px; color: white;" class="xCanvasBtn btn btn-default">x</button>' +
          "<button class='stopper'></button></div>" +
          '<i style="position:absolute; bottom: -4px; right: 2px; font-size: 2em; color: gray; transform: rotate(-45deg);" class="fas fa-sort-down" aria-hidden="true"></i>' +
          '<div class="rotationHandle" style="position:absolute; bottom: -30px; left: 0px; width:100%; text-align:center; cursor:ew-resize;"><i class="fa fa-undo"></i></div>' +
          "</div>"
      );

      imgDiv.prepend(img);
      imgDiv
        .find(".xCanvasBtn")
        .off("click")
        .click(function () {
          _this.imgDragActive = false;
          _this.refreshCursorAppearance();
          imgDiv.remove();
          _this.setTool(oldTool);
        });
      var rotationAngle = 0;
      var recoupLeft = 0;
      var recoupTop = 0;
      var p = imgDiv.position();
      var left = 200;
      var top = 200;

      imgDiv
        .find(".addToCanvasBtn,.addToBackgroundBtn")
        .off("click")
        .click(function () {
          var draw = $(this).attr("draw");
          _this.imgDragActive = false;

          var width = imgDiv.width();
          var height = imgDiv.height();
          var screenWidth = _this._boardWidth();
          var screenHeight = _this._boardHeight();
          var size = [screenWidth, screenHeight];

          if (draw == "1") {
            //draw image to canvas
            _this.drawImgToCanvas(
              size,
              finalURL,
              width,
              height,
              left,
              top,
              rotationAngle
            );
          } else {
            //Add image to background
            _this.drawImgToBackground(
              size,
              finalURL,
              width,
              height,
              left,
              top,
              rotationAngle
            );
          }
          _this.sendFunction({
            t: "addImgBG",
            draw: draw,
            url: finalURL,
            d: [width, height, left, top, rotationAngle],
            s: size,
          });
          _this.drawId++;
          imgDiv.remove();
          _this.refreshCursorAppearance();
          _this.setTool(oldTool);
        });
      _this.mouseOverlay.append(imgDiv);

      imgDiv.draggable({
        containment: "parent",
        start: function (event, ui) {
          var left = parseInt($(this).css("left"), 10);
          left = isNaN(left) ? 0 : left;
          var top = parseInt($(this).css("top"), 10);
          top = isNaN(top) ? 0 : top;
          recoupLeft = left - ui.position.left;
          recoupTop = top - ui.position.top;
        },
        drag: function (event, ui) {
          ui.position.left += recoupLeft;
          ui.position.top += recoupTop;
        },
        stop: function (event, ui) {
          left = ui.position.left - _this.viewCoords.x;
          top = ui.position.top - _this.viewCoords.y;
          setTimeout(function () {
            $(".addToCanvasBtn, .addToBackgroundBtn, .stopper, .xCanvasBtn").on(
              "touchstart touchend click",
              function (e) {
                e.stopPropagation();
              }
            );
          }, 0);
        },
      });

      $(".addToCanvasBtn, .addToBackgroundBtn, .stopper, .xCanvasBtn").on(
        "touchend",
        function (e) {
          e.stopPropagation();
        }
      );

      imgDiv.resizable();
      var params = {
        // Callback fired on rotation start.
        start: function (event, ui) {},
        // Callback fired during rotation.
        rotate: function (event, ui) {
          //console.log(ui)
        },
        // Callback fired on rotation end.
        stop: function (event, ui) {
          rotationAngle = ui.angle.current;
        },
        handle: imgDiv.find(".rotationHandle"),
      };
      imgDiv.rotatable(params);

      imgDiv.css("touch-action", "auto");

      // Allow button clicks inside the draggable div
      imgDiv.find("button").css("pointer-events", "auto");

      // render newly added icons
      dom.i2svg();
      // console.log("Below From dom.i2svg");
      // console.log(dom.i2svg());
      // console.log(imgDiv);
    } catch (error) {
      console.log(error);
      alert("addImgToCanvasByUrl", error);
    }
  },
  setImgAsBackgroundByUrl: async function (
    url,
    imgTempId,
    valueIndex,
    isNewData = false
  ) {
    var _this = this;
    var oldTool = _this.tool;
    var finalURL = url;
    var img = this.imgWithSrc(finalURL).css({ width: "100%", height: "100%" });
    finalURL = img.attr("src");
    $("#ContextImgAsBackground").remove();

    try {
      _this.setTool("mouse"); //Set to mouse tool while dropping to prevent errors
      _this.imgDragActive = true;
      // if (!_this.mouseOverlay)
      //   setTimeout(() => {
      //     _this.mouseOverlay.css({ cursor: "default" });
      //   }, 100);
      // else _this.mouseOverlay.css({ cursor: "default" });

      var rotationAngle = 0;
      var left = 0;
      var top = 0;

      img.attr("id", "ContextImg");
      $("#ContextImg").remove();

      // _this.mouseOverlay?.append(img);
      _this.imgDragActive = false;

      var draw = 0;

      var width = _this._boardWidth();
      var height = _this._boardHeight();
      console.log("size", width, height);

      // var width = img.width;
      // var height = img.height;

      _this.drawId++;

      _this.setImgToBackground(
        finalURL,
        width,
        height,
        left,
        top,
        rotationAngle,
        "ContextImgAsBackground"
      );

      const imgLoad = document.getElementById("ContextImgAsBackground");

      imgLoad.onload = () => {
        _this.adjustBackgroundPosition();
        // Get the rendered dimensions with CSS applied
        const computedStyles = getComputedStyle(imgLoad);
        const renderedWidth = parseInt(computedStyles.width, 10);
        const renderedHeight = parseInt(computedStyles.height, 10);

        if (!isNewData) {
          _this.sendFunction({
            t: "addImgContentAsBG",
            draw: draw,
            url: finalURL,
            d: [
              renderedWidth,
              renderedHeight,
              left,
              top,
              rotationAngle,
              "ContextImgAsBackground",
              imgTempId,
              valueIndex,
            ],
          });
          _this.drawId++;
        }
      };

      imgLoad.onerror = () => {
        console.error("背景图加载失败:", imgLoad.src);
        $("#loadingMedia").css({ display: "none" });
        $("#loadingMedia").css({ zIndex: "0" });
        $(".pageChange").removeAttr("style");
      };

      img.remove();
      _this.refreshCursorAppearance();
      _this.setTool(oldTool);
      dom.i2svg();
    } catch (error) {
      console.log("test123", error);
    }
  },
  drawImgToBackground(size, url, width, height, left, top, rotationAngle) {
    var _this = this;
    var screenWidth = _this._boardWidth();
    var screenHeight = _this._boardHeight();
    // console.error(size, [screenWidth, screenHeight]);
    if (size[0] != screenWidth || size[1] != screenHeight) {
      const scaleX = screenWidth / size[0];
      const scaleY = screenHeight / size[1];
      top = top * scaleY;
      left = left * scaleX;
      width = width * scaleX;
      height = height * scaleY;
    }

    const px = (v) => Number(v).toString() + "px";
    this.imgContainer.append(
      this.imgWithSrc(url).css({
        width: px(width),
        height: px(height),
        top: px(top + _this.viewCoords.y),
        left: px(left + _this.viewCoords.x),
        position: "absolute",
        transform: "rotate(" + Number(rotationAngle) + "rad)",
      })
    );
  },
  setImgToBackground(url, width, height, left, top, rotationAngle, id) {
    let img = document.getElementById(id);
    if (!img) {
      img = this.imgWithSrcAndId(url, id).appendTo(this.imgContainer)[0];
    }
    $(img).css({
      width: "100%",
      top: Number(top + this.viewCoords.y) + "px",
      left: Number(left + this.viewCoords.x) + "px",
      position: "absolute",
      transform: "rotate(" + Number(rotationAngle) + "rad)",
    });
  },
  changeCanvasSizeBaseOnContext(imgLoad, width, height) {
    height = $("#ContextImgAsBackground").height();
    this.imageHeight = height;
    this.imageWidth = width;
    const renderedWidth = this.imageWidth;
    const renderedHeight = this.imageHeight;

    this.canvas.width = renderedWidth;
    this.canvas.height = renderedHeight;
    // $("#whiteboardCanvas").css({ width: renderedWidth, height: renderedHeight });
    $("#textContainer").css({ width: renderedWidth, height: renderedHeight });
    $("#mouseOverlay").css({ width: renderedWidth, height: renderedHeight });
    $("#imgContainer").css({ width: renderedWidth, height: renderedHeight });
    $("#backgroundGrid").css({ width: renderedWidth, height: renderedHeight });
    $("#svgContainer").css({ width: renderedWidth, height: renderedHeight });
    $("#dropIndicator").css({ width: renderedWidth, height: renderedHeight });
    $("#cursorContainer").css({ width: renderedWidth, height: renderedHeight });
    $("#loadingMedia").css({ width: renderedWidth, height: renderedHeight });
  },
  changeMaterialState(id) {
    var element = document.getElementById(id).firstChild;
    element.style.border = "5px solid cornflowerblue";
  },
  updateValue(store, newValue) {
    store.dispatch("updateValue", newValue);
  },
  addTextBox(
    size,
    textcolor,
    textboxBackgroundColor,
    fontsize,
    left,
    top,
    txId,
    isStickyNote,
    username,
    newLocalBox,
    remote
  ) {
    // 防止重複載入同一個文字框（JSON 與即時快照都含有相同 txId 時）
    if (txId && document.getElementById(txId)) return;
    var _this = this;
    var cssclass = "textBox";
    var minWidth = 50;
    if (isStickyNote) {
      cssclass += " stickyNote";
    }
    if (remote) {
      var width = _this._boardWidth();
      var height = _this._boardHeight();
      const scaleX = width / size[0];
      const scaleY = height / size[1];
      left = left * scaleX;
      top = top * scaleY;
      fontsize = fontsize * scaleX;
      minWidth = minWidth * scaleX;
    }
    left = left + _this.viewCoords.x;
    top = top + _this.viewCoords.y;
    let editable =
      _this.tool == "text" || _this.tool === "stickynote" ? "true" : "false";
    let sameUsername = username == _this.settings.username;
    var option = !remote
      ? '<div title="remove textbox" class="removeIcon" style="position:absolute; cursor:pointer; top:-3px; right:2px;"><b>🗑</b></div>' +
        '<div title="move textbox" class="moveIcon" style="position:absolute; cursor:move; top:1px; left:2px; font-size: 0.5em;"><i class="fas fa-expand-arrows-alt"></i></div>'
      : sameUsername
      ? '<div title="remove textbox" class="removeIcon" style="position:absolute; cursor:pointer; top:-3px; right:2px;"><b>🗑</b></div>' +
        '<div title="move textbox" class="moveIcon" style="position:absolute; cursor:move; top:1px; left:2px; font-size: 0.5em;"><i class="fas fa-expand-arrows-alt"></i></div>'
      : "";

    var textBox = $(
      '<div id="' +
        txId +
        '" class="' +
        cssclass +
        '" style="font-family: Monospace; position:absolute; top:' +
        top +
        "px; left:" +
        left +
        "px;" +
        "background-color:" +
        textboxBackgroundColor +
        ';">' +
        '<div contentEditable="' +
        editable +
        '" spellcheck="false" class="textContent" style="outline: none; font-size:' +
        fontsize +
        "em; color:" +
        textcolor +
        `; min-width:${minWidth}px; min-height:100%;"></div>` +
        option +
        "</div>"
    );
    _this.latestActiveTextBoxId = txId;

    textBox.click(function (e) {
      e.preventDefault();
      _this.latestActiveTextBoxId = txId;
      return false;
    });
    textBox.on("mousemove touchmove", function (e) {
      e.preventDefault();
      if (_this.imgDragActive) {
        return;
      }

      var textBoxPosition = textBox.position();
      var currX = e.offsetX + textBoxPosition.left;
      var currY = e.offsetY + textBoxPosition.top;
      if ($(e.target).hasClass("removeIcon")) {
        currX += textBox.width() - 4;
      }

      const newPointerPosition = new Point(currX, currY);

      ThrottlingService.throttle(newPointerPosition, () => {
        _this.lastPointerPosition = newPointerPosition;
        _this.sendFunction({
          t: "cursor",
          event: "move",
          d: [newPointerPosition.x, newPointerPosition.y, size[0], size[1]],
          username: _this.settings.username,
        });
      });
    });
    this.textContainer.append(textBox);
    textBox.draggable({
      handle: ".moveIcon",
      start: function (event, ui) {},
      stop: function (event, ui) {
        var textBoxPosition = textBox.position();
        console.error("Stop", [event.clientY, event.clientX], textBoxPosition);
        _this.sendFunction({
          t: "setTextboxPosition",
          d: [
            txId,
            textBoxPosition.top - _this.viewCoords.y,
            textBoxPosition.left - _this.viewCoords.x,
            size[0],
            size[1],
          ],
        });
      },
      drag: function (event, ui) {
        var textBoxPosition = textBox.position();
        const textContainer = document.getElementById("textContainer");
        const style = window.getComputedStyle(textContainer);
        const transform = style.transform;
        const scaleMatch = transform.match(/matrix\(([^)]+)\)/);
        const scaleValues = scaleMatch
          ? scaleMatch[1].split(", ")
          : [1, 0, 0, 1];
        const scaleX = parseFloat(scaleValues[0]);
        const scaleY = parseFloat(scaleValues[3]);

        ui.position.left =
          event.clientX / scaleX -
          textContainer.getBoundingClientRect().left / scaleX;
        ui.position.top =
          event.clientY / scaleX -
          textContainer.getBoundingClientRect().top / scaleX;

        _this.sendFunction({
          t: "setTextboxPosition",
          d: [
            txId,
            textBoxPosition.top - _this.viewCoords.y,
            textBoxPosition.left - _this.viewCoords.x,
            size[0],
            size[1],
          ],
        });
      },
    });
    textBox.find(".textContent").on("input", function () {
      var text = btoa(unescape(encodeURIComponent($(this).html()))); //Get html and make encode base64 also take care of the charset
      _this.sendFunction({ t: "setTextboxText", d: [txId, text] });
    });
    textBox
      .find(".removeIcon")
      .off("click")
      .click(function (e) {
        $("#" + txId).remove();
        _this.sendFunction({ t: "removeTextbox", d: [txId] });
        e.preventDefault();
        return false;
      });
    if (newLocalBox) {
      //per https://stackoverflow.com/questions/2388164/set-focus-on-div-contenteditable-element
      setTimeout(() => {
        textBox.find(".textContent").focus();
      }, 0);
    }
    if (this.tool === "text" || this.tool === "stickynote") {
      textBox.addClass("active");
    }

    // render newly added icons
    dom.i2svg();
  },
  setTextboxText(txId, text) {
    $("#" + txId)
      .find(".textContent")
      .html(decodeURIComponent(escape(atob(text)))); //Set decoded base64 as html
  },
  removeTextbox(txId) {
    $("#" + txId).remove();
  },
  setTextboxPosition(txId, top, left, width, height) {
    var screenWidth = _this._boardWidth();
    var screenHeight = _this._boardHeight();
    const scaleX = screenWidth / width;
    const scaleY = screenHeight / height;
    top = top * scaleY;
    left = left * scaleX;

    $("#" + txId).css({
      top: top + this.viewCoords.y + "px",
      left: left + this.viewCoords.x + "px",
    });
  },
  setTextboxFontSize(txId, fontSize) {
    $("#" + txId)
      .find(".textContent")
      .css({ "font-size": fontSize + "em" });
  },
  setTextboxFontColor(txId, color) {
    $("#" + txId)
      .find(".textContent")
      .css({ color: color });
  },
  setTextboxBackgroundColor(txId, textboxBackgroundColor) {
    $("#" + txId)
      .find(".textContent")
      .css({ "background-color": textboxBackgroundColor });
  },
  drawImgToCanvas(
    size,
    url,
    width,
    height,
    left,
    top,
    rotationAngle,
    doneCallback
  ) {
    top = Number(top); // probably not as important here
    left = Number(left); // as it is when generating html
    width = Number(width);
    height = Number(height);
    rotationAngle = Number(rotationAngle);
    var screenWidth = _this._boardWidth();
    var screenHeight = _this._boardHeight();

    if (size[0] != screenWidth || size[1] != screenHeight) {
      const scaleX = screenWidth / size[0];
      const scaleY = screenHeight / size[1];
      top = top * scaleY;
      left = left * scaleX;
      width = width * scaleX;
      height = height * scaleY;
    }

    var _this = this;
    var img = document.createElement("img");
    img.onload = function () {
      rotationAngle = rotationAngle ? rotationAngle : 0;
      if (rotationAngle === 0) {
        _this.ctx.drawImage(
          img,
          left + _this.viewCoords.x,
          top + _this.viewCoords.y,
          width,
          height
        );
      } else {
        _this.ctx.save();
        _this.ctx.translate(
          left + _this.viewCoords.x + width / 2,
          top + _this.viewCoords.y + height / 2
        );
        _this.ctx.rotate(rotationAngle);
        _this.ctx.drawImage(img, -(width / 2), -(height / 2), width, height);
        _this.ctx.restore();
      }
      if (doneCallback) {
        doneCallback();
      }
    };

    img.src = this.imgWithSrc(url).attr("src"); // or here - but consistent
  },
  undoWhiteboard: function (username) {
    //Not call this directly because you will get out of sync whith others...
    var _this = this;
    if (!username) {
      username = _this.settings.username;
    }
    for (var i = _this.drawBuffer.length - 1; i >= 0; i--) {
      if (_this.drawBuffer[i]["username"] == username) {
        var drawId = _this.drawBuffer[i]["drawId"];
        for (var i = _this.drawBuffer.length - 1; i >= 0; i--) {
          if (
            _this.drawBuffer[i]["drawId"] == drawId &&
            _this.drawBuffer[i]["username"] == username
          ) {
            _this.undoBuffer.push(_this.drawBuffer[i]);
            _this.drawBuffer.splice(i, 1);
          }
        }
        break;
      }
    }
    if (_this.undoBuffer.length > 1000) {
      _this.undoBuffer.splice(0, _this.undoBuffer.length - 1000);
    }
    _this.canvas.height = _this.canvas.height;
    _this.imgContainer.empty();
    _this.loadDataInSteps(_this.drawBuffer, false, function (stepData) {
      //Nothing to do
    });
  },
  redoWhiteboard: function (username) {
    //Not call this directly because you will get out of sync whith others...
    var _this = this;
    if (!username) {
      username = _this.settings.username;
    }
    for (var i = _this.undoBuffer.length - 1; i >= 0; i--) {
      if (_this.undoBuffer[i]["username"] == username) {
        var drawId = _this.undoBuffer[i]["drawId"];
        for (var i = _this.undoBuffer.length - 1; i >= 0; i--) {
          if (
            _this.undoBuffer[i]["drawId"] == drawId &&
            _this.undoBuffer[i]["username"] == username
          ) {
            _this.drawBuffer.push(_this.undoBuffer[i]);
            _this.undoBuffer.splice(i, 1);
          }
        }
        break;
      }
    }
    _this.canvas.height = _this.canvas.height;
    _this.imgContainer.empty();
    _this.loadDataInSteps(_this.drawBuffer, false, function (stepData) {
      //Nothing to do
    });
  },
  undoWhiteboardClick: function () {
    if (ReadOnlyService.readOnlyActive) return;
    this.sendFunction({ t: "undo" });
    this.undoWhiteboard();
  },
  redoWhiteboardClick: function () {
    if (ReadOnlyService.readOnlyActive) return;
    this.sendFunction({ t: "redo" });
    this.redoWhiteboard();
  },
  setTool: function (tool) {
    this.tool = tool;
    if (this.tool === "text" || this.tool === "stickynote") {
      $(".textBox").addClass("active");
      this.textContainer.appendTo($(whiteboardContainer)); //Bring textContainer to the front
      $(".textContent").attr("contenteditable", "true");
    } else {
      $(".textBox").removeClass("active");
      if (this.mouseOverlay !== null) {
        this.mouseOverlay.appendTo($(whiteboardContainer));
      }
      $(".textContent").attr("contenteditable", "false");
    }
    if (this.mouseOverlay !== null) {
      this.refreshCursorAppearance();
      this.mouseOverlay.find(".xCanvasBtn").click();
    }
    this.latestActiveTextBoxId = null;
  },
  setMove: function (tool) {
    var _this = this;
    _this.tool = tool;
    var groupedByDrawId = {};
    _this.drawBuffer.forEach((item) => {
      if (!groupedByDrawId[item.drawId]) {
        groupedByDrawId[item.drawId] = [];
      }
      groupedByDrawId[item.drawId].push(item);
    });

    var width = _this._boardWidth();
    var height = _this._boardHeight();
    var size = [width, height];

    const rectangles = [];
    Object.entries(groupedByDrawId).forEach(([drawId, items]) => {
      let minX = Infinity,
        minY = Infinity,
        maxX = -Infinity,
        maxY = -Infinity;
      var type = "";
      var lineWidth = 0;

      items.forEach((item) => {
        type = item.t;
        lineWidth = item.th;

        if (item.t === "pen" && Array.isArray(item.d)) {
          // Pen drawing: `d` contains an array of points [[x1, y1], [x2, y2], ...]
          const [x, y] = item.d;
          minX = Math.min(minX, x);
          minY = Math.min(minY, y);
          maxX = Math.max(maxX, x);
          maxY = Math.max(maxY, y);
        } else if (item.t === "rect" && Array.isArray(item.d)) {
          // Rectangle: `d` contains [x, y, width, height]
          const [x, y, width, height] = item.d;
          minX = Math.min(minX, x);
          minY = Math.min(minY, y);
          maxX = Math.max(maxX, x + width);
          maxY = Math.max(maxY, y + height);
        } else if (item.t === "circle" && Array.isArray(item.d)) {
          // Circle: `d` contains [cx, cy, r]
          const [cx, cy, r] = item.d;
          minX = Math.min(minX, cx - r);
          minY = Math.min(minY, cy - r);
          maxX = Math.max(maxX, cx + r);
          maxY = Math.max(maxY, cy + r);
        } else if (item.t === "line" && Array.isArray(item.d)) {
          // Line: `d` contains [x1, y1, x2, y2]
          const [x1, y1, x2, y2] = item.d;
          minX = Math.min(minX, x1, x2);
          minY = Math.min(minY, y1, y2);
          maxX = Math.max(maxX, x1, x2);
          maxY = Math.max(maxY, y1, y2);
        }
      });

      // Calculate coordinates for imgDiv and dragCanvasObjContent, accounting for lineWidth
      let coor = [];
      if (type === "pen") {
        coor = [
          minX - lineWidth,
          minY - lineWidth,
          maxX - minX + lineWidth * 2,
          maxY - minY + lineWidth * 2,
        ];
      } else if (type === "rect") {
        coor = [
          minX - lineWidth,
          minY - lineWidth,
          maxX - 2 * (minX - lineWidth),
          maxY - 2 * (minY - lineWidth),
        ];
      } else if (type === "circle") {
        const radius = Math.max(maxX - minX, maxY - minY) / 2 + lineWidth / 2;
        const centerX = (minX + maxX) / 2;
        const centerY = (minY + maxY) / 2;
        coor = [centerX - radius, centerY - radius, radius * 2, radius * 2];
      } else if (type === "line") {
        // Calculate bounding box for line if needed, accounting for lineWidth
      }

      // Set dimensions and position
      let left = coor[0];
      let top = coor[1];
      let width = coor[2];
      let height = coor[3];

      _this.imgDragActive = true;
      _this.mouseOverlay.css({ cursor: "default" });

      const imgDiv = $(`
  <div class="dragMe" style="position:absolute; left:${left}px; top:${top}px; width:${width}px; height:${height}px; border:2px dotted gray; overflow:hidden; background:rgba(173, 216, 230, 0.25); cursor:move;">
    <canvas style="cursor:move; position:absolute; top:0px; left:0px;" width="${width}" height="${height}"></canvas>
    <div style="position:absolute; right:0px; top:0px;">
      <button draw="1" style="margin:0px; background:#03a9f4; padding:5px; color:white;" class="addToCanvasBtn btn btn-default">Drop</button>
      <button style="margin:0px; background:#03a9f4; padding:5px; color:white;" class="xCanvasBtn btn btn-default">x</button>
    </div>
  </div>
`);
      const dragCanvas = $(imgDiv).find("canvas");

      // Append to overlay
      _this.mouseOverlay.append(imgDiv);

      // Draw the exact area of the object on the canvas
      const tempCanvas = _this.drawShapes(items, type);
      const destCanvasContext = dragCanvas[0].getContext("2d");

      destCanvasContext.drawImage(
        tempCanvas,
        minX - lineWidth / 2,
        minY - lineWidth / 2,
        width,
        height,
        0,
        0,
        width,
        height
      );

      // Handle removal
      imgDiv
        .find(".xCanvasBtn")
        .off("click")
        .click(function () {
          _this.imgDragActive = false;
          _this.refreshCursorAppearance();
          _this.cancelEraseRec();
          console.error(_this.drawBuffer);
          imgDiv.remove();
        });

      // Handle drop
      imgDiv
        .find(".addToCanvasBtn")
        .off("click")
        .click(function () {
          _this.imgDragActive = false;
          const p = imgDiv.position();
          let leftT = null;
          let topT = null;

          if (type === "pen") {
            left = left + lineWidth / 2;
            top = top + lineWidth / 2;
            width = width + lineWidth;
            height = height + lineWidth;

            leftT = Math.round(p.left * 100) / 100 + lineWidth / 2;
            topT = Math.round(p.top * 100) / 100 + lineWidth / 2;
          } else if (type === "rect") {
            left = left + lineWidth / 2;
            top = top + lineWidth / 2;
            width = width + lineWidth;
            height = height + lineWidth;

            leftT = Math.round(p.left * 100) / 100 + lineWidth / 2;
            topT = Math.round(p.top * 100) / 100 + lineWidth / 2;
          }

          const offsetX = leftT - left;
          const offsetY = topT - top;

          let updatedItems = [];
          let itemType = null;
          // Update drawBuffer
          groupedByDrawId[drawId].forEach((item) => {
            if (item.t === "rect" && Array.isArray(item.d)) {
              // Rectangle: Adjust [x, y, width, height]
              item.d[0] += offsetX; // x
              item.d[1] += offsetY; // y
              item.d[2] += offsetX; // x + width
              item.d[3] += offsetY; // y + height
            } else if (item.t === "pen" && Array.isArray(item.d)) {
              // Pen: Adjust each point
              for (let i = 0; i < item.d.length; i += 2) {
                item.d[i] += offsetX; // x
                item.d[i + 1] += offsetY; // y
              }
            } else if (item.t === "circle" && Array.isArray(item.d)) {
              // Circle: Adjust center [cx, cy]
              item.d[0] += offsetX; // cx
              item.d[1] += offsetY; // cy
            } else if (item.t === "line" && Array.isArray(item.d)) {
              // Line: Adjust both points [x1, y1, x2, y2]
              item.d[0] += offsetX; // x1
              item.d[1] += offsetY; // y1
              item.d[2] += offsetX; // x2
              item.d[3] += offsetY; // y2
            }
            updatedItems.push(item);
            itemType = item.t;
          });

          _this.sendFunction({
            t: _this.tool,
            d: [
              left - _this.viewCoords.x, // Original left
              top - _this.viewCoords.y, // Original top
              leftT - _this.viewCoords.x, // Translated left
              topT - _this.viewCoords.y, // Translated top
              width,
              height,
              true,
              updatedItems,
              itemType,
              coor,
              _this.drawBuffer,
            ],
            s: size,
          });

          _this.dragCanvasObjContent(
            left,
            top,
            leftT,
            topT,
            width,
            height,
            false,
            tempCanvas,
            size,
            coor
          );
          imgDiv.remove();
        });

      let lastEraseTime = 0;

      // Add draggable functionality
      imgDiv.draggable({
        drag: function (event, ui) {
          const now = Date.now();
          if (now - lastEraseTime > 100) {
            _this.eraseRec(left, top, width, height, false, drawId);
            lastEraseTime = now;
          }
        },
      });
      _this.svgContainer.find("rect").remove();
    });
  },
  implementMove: function (drawBuffer) {
    var _this = this;
    _this.dbCp = JSON.parse(JSON.stringify(drawBuffer));
    var width = _this._boardWidth();
    var height = _this._boardHeight();
    _this.canvas.width = width;
    _this.canvas.height = height;
    _this.drawBuffer = [];
    _this.textContainer.empty();
    _this.loadData(_this.dbCp);
    _this.dbCp = [];
  },
  drawShapes(items, type, remote, size) {
    var _this = this;
    const canvas = document.createElement("canvas");
    var width = _this._boardWidth();
    var height = _this._boardHeight();
    canvas.width = width;
    canvas.height = height;

    const ctx = canvas.getContext("2d");
    items.forEach((item) => {
      if (type === "rect" && item.t === "rect") {
        let [left, top, wObj, hObj, thickness] = [
          item.d[0],
          item.d[1],
          item.d[2] - item.d[0],
          item.d[3] - item.d[1],
          item.th,
        ];

        if (remote) {
          const scaleX = width / size[0];
          const scaleY = height / size[1];
          left *= scaleX;
          top *= scaleY;
          wObj *= scaleX;
          hObj *= scaleY;
          const scale = Math.min(scaleX, scaleY);
          thickness = thickness * scale;
        }
        ctx.beginPath();
        ctx.rect(left, top, wObj, hObj);
        ctx.strokeStyle = item.c || "red";
        ctx.lineWidth = thickness || 1;
        ctx.stroke();
        ctx.closePath();
      } else if (type === "pen" && item.t === "pen") {
        var xm1 = item.d[0];
        var ym1 = item.d[1];
        var x0 = item.d[2];
        var y0 = item.d[3];
        var x1 = item.d[4];
        var y1 = item.d[5];
        var x2 = item.d[6];
        var y2 = item.d[7];

        var length = Math.sqrt(Math.pow(x0 - x1, 2) + Math.pow(y0 - y1, 2));
        var steps = Math.ceil(length / 5);
        ctx.beginPath();
        let xOffset = 0;
        let yOffset = 0;
        ctx.moveTo(x0 + xOffset, y0 + yOffset);
        if (steps == 0) {
          ctx.lineTo(x0 + xOffset, y0 + yOffset);
        }
        for (var i = 0; i < steps; i++) {
          var point = lanczosInterpolate(
            xm1,
            ym1,
            x0,
            y0,
            x1,
            y1,
            x2,
            y2,
            (i + 1) / steps
          );
          ctx.lineTo(point[0] + xOffset, point[1] + yOffset);
        }
        ctx.strokeStyle = item.c;
        ctx.lineWidth = item.th;
        ctx.lineCap = _this.lineCap;
        ctx.stroke();
        ctx.closePath();
      }
    });

    return canvas;
  },
  setDrawColor(color) {
    var _this = this;
    _this.drawcolor = color;
    //$("#whiteboardColorpicker").css({ background: color });
    if (
      (_this.tool == "text" || _this.tool === "stickynote") &&
      _this.latestActiveTextBoxId
    ) {
      _this.sendFunction({
        t: "setTextboxFontColor",
        d: [_this.latestActiveTextBoxId, color],
      });
      _this.setTextboxFontColor(_this.latestActiveTextBoxId, color);
    }
  },
  setTextBackgroundColor(textboxBackgroundColor) {
    var _this = this;
    _this.textboxBackgroundColor = textboxBackgroundColor;
    $("#textboxBackgroundColorPicker").css({
      background: textboxBackgroundColor,
    });
    if (
      (_this.tool == "text" || this.tool === "stickynote") &&
      _this.latestActiveTextBoxId
    ) {
      _this.sendFunction({
        t: "setTextboxBackgroundColor",
        d: [_this.latestActiveTextBoxId, textboxBackgroundColor],
      });
      _this.setTextboxBackgroundColor(
        _this.latestActiveTextBoxId,
        textboxBackgroundColor
      );
    }
  },
  updateSmallestScreenResolution() {
    // const { smallestScreenResolution } = InfoService;
    // const { showSmallestScreenIndicator } = ConfigService;
    // if (showSmallestScreenIndicator && smallestScreenResolution) {
    //   const { w: width, h: height } = smallestScreenResolution;
    //   this.backgroundGrid.empty();
    //   if (width < $(window).width() || height < $(window).height()) {
    //     this.backgroundGrid.append(
    //       '<div style="position:absolute; left:0px; top:0px; border-right:3px dotted black; border-bottom:3px dotted black; width:' +
    //         width +
    //         "px; height:" +
    //         height +
    //         'px;"></div>'
    //     );
    //     this.backgroundGrid.append(
    //       '<div style="position:absolute; left:' +
    //         (width + 5) +
    //         'px; top:0px;">smallest screen participating</div>'
    //     );
    //   }
    // }
  },
  delay(delayInms) {
    return new Promise((resolve) => setTimeout(resolve, delayInms));
  },
  fullscreen(videoState, originalWidth, originalHeight) {
    var _this = this;
    const dbCp = JSON.parse(JSON.stringify(_this.drawBuffer));

    // 保存当前背景图URL，防止drawBuffer中还没有该条目时（socket未回传完成）丢失教材
    const bgImgEl = document.getElementById("ContextImgAsBackground");
    const bgImgUrl = bgImgEl ? bgImgEl.src : null;
    const hasBGInBuffer = dbCp.some(
      (item) => item && item["t"] === "addImgContentAsBG"
    );

    setTimeout(() => {
      // 全屏切換後容器尺寸已改變，直接讀取容器的當前尺寸
      var width = _this.containerEl ? _this.containerEl.clientWidth : _this._boardWidth();
      var height = _this.containerEl ? _this.containerEl.clientHeight : _this._boardHeight();
      _this.canvas.width = width;
      _this.canvas.height = height;
      // whiteboardInner 同步更新至容器尺寸（背景圖加載後 adjustBackgroundPosition 會再調整）
      $("#whiteboardInner").css({ width: width + "px", height: height + "px" });

      _this.drawBuffer = [];
      _this.textContainer.empty();
      _this.imgContainer.empty();
      _this.loadData(dbCp);

      // 竞态兜底：背景图在DOM中但未进入drawBuffer，全屏后直接恢复
      if (bgImgUrl && !hasBGInBuffer) {
        _this.setImgToBackground(bgImgUrl, 0, 0, 0, 0, 0, "ContextImgAsBackground");
        const restored = document.getElementById("ContextImgAsBackground");
        if (restored) {
          if (restored.complete) {
            _this.adjustBackgroundPosition();
          } else {
            restored.onload = () => _this.adjustBackgroundPosition();
          }
        }
      }

      const mouseOverlay = document.getElementById("mouseOverlay");
      const elements = mouseOverlay.children;

      const currentWidth = _this._boardWidth();
      const currentHeight = _this._boardHeight();
      const widthScale = currentWidth / originalWidth;
      const heightScale = currentHeight / originalHeight;

      _this.thickness = _this.thickness * widthScale;

      Array.from(elements).forEach((element) => {
        const top = parseFloat(element.style.top) || 0;
        const left = parseFloat(element.style.left) || 0;
        const rect = element.getBoundingClientRect();
        const elHeight = rect.height;
        const elWidth = rect.width;
        const newLeft = left * widthScale;
        const newTop = top * heightScale;

        const newElHeight = elHeight * heightScale;
        const newElWidth = elWidth * widthScale;
        element.style.top = `${newTop}px`;
        element.style.left = `${newLeft}px`;
        element.style.height = `${newElHeight}px`;
        element.style.width = `${newElWidth}px`;
      });
    }, 50);

    if (videoState) {
      setTimeout(() => {
        var popupVideoElement = document.getElementById("hi_popup_video");
        var whiteboardContainer = document.getElementById(
          "whiteboardContainer"
        );

        popupVideoElement.style.cssText = `
          display: flex;
          flex-direction: column;
          position: absolute;
          z-index: 1;
          width: ${whiteboardContainer.clientWidth}px;
          height: ${whiteboardContainer.clientHeight}px;
          top: ${
            whiteboardContainer.getBoundingClientRect().top + window.scrollY
          }px;
          left: ${whiteboardContainer.getBoundingClientRect().left}px;
      `;
      }, 100);
    }
  },
  handleEventsAndData: function (content, isNewData, doneCallback, skipRAF) {
    var _this = this;
    var tool = content["t"];
    var data = content["d"];
    var color = content["c"];
    var username = content["username"];
    var thickness = content["th"];
    var size = content["s"];

    var renderFn = function () {
      if (tool === "line" || tool === "pen") {
        if (data.length == 4) {
          //Only used for old json imports
          _this.drawPenLine(
            size,
            data[0],
            data[1],
            data[2],
            data[3],
            color,
            thickness,
            true
          );
        } else {
          _this.drawPenSmoothLine(data, color, thickness, true);
        }
      } else if (tool === "arrow") {
        _this.drawArrow(
          size,
          data[0],
          data[1],
          data[2],
          data[3],
          color,
          thickness,
          true
        );
      } else if (tool === "rect") {
        _this.drawRec(
          size,
          data[0],
          data[1],
          data[2],
          data[3],
          color,
          thickness,
          true
        );
      } else if (tool === "triangle") {
        _this.drawTriangle(
          size,
          data[0],
          data[1],
          data[2],
          data[3],
          data[4],
          data[5],
          color,
          thickness,
          true
        );
        // } else if (tool === "circle") {
        //   _this.drawCircle(
        //     size,
        //     data[0],
        //     data[1],
        //     data[2],
        //     color,
        //     thickness,
        //     true
        //   );
      } else if (tool === "circle") {
        _this.drawCircle(
          size,
          data[0],
          data[1],
          data[2],
          data[3],
          color,
          thickness,
          true
        );
      } else if (tool === "ellipse") {
        _this.drawEllipse(
          size,
          data[0],
          data[1],
          data[2],
          data[3],
          color,
          thickness,
          true
        );
      } else if (tool === "eraser") {
        _this.drawEraserLine(
          size,
          data[0],
          data[1],
          data[2],
          data[3],
          thickness,
          true
        );
      } else if (tool === "eraseRec") {
        _this.eraseRec(data[0], data[1], data[2], data[3], true);
      } else if (tool === "recSelect") {
        _this.dragCanvasRectContent(
          data[0],
          data[1],
          data[2],
          data[3],
          data[4],
          data[5],
          true
        );
      } else if (tool === "move") {
        _this.implementMove(data[10]);
      } else if (tool === "addImgBG") {
        if (content["draw"] == "1") {
          _this.drawImgToCanvas(
            size,
            content["url"],
            data[0],
            data[1],
            data[2],
            data[3],
            data[4],
            doneCallback
          );
        } else {
          _this.drawImgToBackground(
            size,
            content["url"],
            data[0],
            data[1],
            data[2],
            data[3],
            data[4]
          );
        }
      } else if (tool === "addImgContentAsBG") {
        _this.setImgToBackground(
          content["url"],
          data[0],
          data[1],
          data[2],
          data[3],
          data[4],
          data[5],
          data[6],
          data[7]
        );
        $("#undefined").remove();
        if (document.querySelectorAll("#ContextImgAsBackground").length > 1) {
          $("#ContextImgAsBackground").first().remove();
        }
        _this.currentIndex = data[6];
        const imgLoad = document.getElementById("ContextImgAsBackground");

        if (imgLoad.complete) {
          // isNewData=false 表示這是 adjustBackgroundPosition 重播時的回呼，
          // 跳過再次調用 adjustBackgroundPosition 以防止無限 rAF 循環導致畫布持續閃爍
          if (isNewData !== false) _this.adjustBackgroundPosition();
          if (!_this.resizeFinished) _this.resizeFinished = true;
          if (doneCallback) doneCallback();
        } else {
          imgLoad.onload = async () => {
            await _this.waitForFullImageDecode(imgLoad);

            if (isNewData !== false) _this.adjustBackgroundPosition();

            if (!_this.resizeFinished) _this.resizeFinished = true;
            if (doneCallback) doneCallback();
          };
          imgLoad.onerror = () => {
            console.error("背景图加载失败:", imgLoad.src);
            // 图片加载失败时也要继续回调链，防止加载流程卡死
            $("#loadingMedia").css({ display: "none" });
            $("#loadingMedia").css({ zIndex: "0" });
            $(".pageChange").removeAttr("style");
            if (!_this.resizeFinished) _this.resizeFinished = true;
            if (doneCallback) doneCallback();
          };
        }
      } else if (tool === "addTextBox") {
        _this.addTextBox(
          size,
          data[0],
          data[1],
          data[2],
          data[3],
          data[4],
          data[5],
          data[6],
          data[7],
          true,
          true
        );
      } else if (tool === "setTextboxText") {
        _this.setTextboxText(data[0], data[1]);
      } else if (tool === "removeTextbox") {
        _this.removeTextbox(data[0]);
      } else if (tool === "setTextboxPosition") {
        _this.setTextboxPosition(data[0], data[1], data[2], data[3], data[4]);
      } else if (tool === "setTextboxFontSize") {
        _this.setTextboxFontSize(data[0], data[1]);
      } else if (tool === "setTextboxFontColor") {
        _this.setTextboxFontColor(data[0], data[1]);
      } else if (tool === "setTextboxBackgroundColor") {
        _this.setTextboxBackgroundColor(data[0], data[1]);
      } else if (tool === "clear") {
        _this.canvas.height = _this.canvas.height;
        _this.imgContainer.empty();
        _this.textContainer.empty();
        _this.drawBuffer = [];
        _this.pendingBuffer = [];
        _this.undoBuffer = [];
        _this.drawId = 0;
      } else if (tool === "clearDrawing") {
        _this.canvas.height = _this.canvas.height;
        _this.textContainer.empty();
        _this.drawBuffer = [];
        _this.undoBuffer = [];
        _this.drawId = 0;
      } else if (tool === "cursor" && _this.settings) {
        if (content["event"] === "move") {
          var width = _this._boardWidth();
          var height = _this._boardHeight();
          const scaleX = width / data[2];
          const scaleY = height / data[3];
          data[0] = data[0] * scaleX;
          data[1] = data[1] * scaleY;

          if (
            _this.cursorContainer.find("." + content["username"]).length >= 1
          ) {
            _this.cursorContainer.find("." + content["username"]).css({
              left: data[0] + _this.viewCoords.x + "px",
              top: data[1] + _this.viewCoords.y - 15 + "px",
            });
          } else {
            _this.cursorContainer.append(
              '<div style="font-size:0.8em; padding-left:2px; padding-right:2px; background:gray; color:white; border-radius:3px; position:absolute; left:' +
                (data[0] + _this.viewCoords.x) +
                "px; top:" +
                (data[1] + _this.viewCoords.y - 151) +
                'px;" class="userbadge ' +
                content["username"] +
                '">' +
                '<div style="width:4px; height:4px; background:gray; position:absolute; top:13px; left:-2px; border-radius:50%;"></div>' +
                decodeURIComponent(atob(content["username"])) +
                "</div>"
            );
          }
        } else {
          _this.cursorContainer.find("." + content["username"]).remove();
        }
      } else if (tool === "undo") {
        _this.undoWhiteboard(username);
      } else if (tool === "redo") {
        _this.redoWhiteboard(username);
      }
    };

    if (skipRAF) {
      renderFn();
    } else {
      window.requestAnimationFrame(renderFn);
    }

    if (
      [
        "line",
        "arrow",
        "pen",
        "rect",
        "triangle",
        "circle",
        "ellipse",
        "eraser",
        "addImgBG",
        "addImgContentAsBG",
        "recSelect",
        "eraseRec",
        "addTextBox",
        "setTextboxText",
        "removeTextbox",
        "setTextboxPosition",
        "setTextboxFontSize",
        "setTextboxFontColor",
        "setTextboxBackgroundColor",
      ].includes(tool)
    ) {
      content["drawId"] = content["drawId"] ? content["drawId"] : _this.drawId;
      content["username"] = content["username"]
        ? content["username"]
        : _this.settings.username;
      _this.drawBuffer.push(content);

      if (document.visibilityState === "hidden" || !document.hasFocus())
        this.pendingBuffer = [..._this.drawBuffer];
    }
  },
  // 批量渲染远端绘图事件：同一帧内的多个事件合并为一次 rAF，避免笔划闪烁断续
  drawToWhiteboardRemote: function (content, isNewData) {
    var _this = this;
    // 图片类型事件需要异步回调链，保持单独 rAF 处理
    if (content && (content.t === "addImgBG" || content.t === "addImgContentAsBG")) {
      _this.handleEventsAndData(content, isNewData);
      return;
    }
    if (!_this._remoteDrawQueue) _this._remoteDrawQueue = [];
    _this._remoteDrawQueue.push({ content: content, isNewData: isNewData });
    if (!_this._remoteDrawRAF) {
      _this._remoteDrawRAF = window.requestAnimationFrame(function () {
        _this._remoteDrawRAF = null;
        var queue = _this._remoteDrawQueue.splice(0);
        for (var i = 0; i < queue.length; i++) {
          _this.handleEventsAndData(queue[i].content, queue[i].isNewData, null, true);
        }
      });
    }
  },
  adjustBackgroundPosition() {
    var _this = this;
    // 使用容器當前寬度（_boardWidth 返回 containerEl.clientWidth）
    var width = _this._boardWidth();
    $("#ContextImgAsBackground").css({ width: width, height: "auto" });
    var height = $("#ContextImgAsBackground").height();
    // #whiteboardInner 跟隨圖片實際尺寸，使覆蓋層與畫布保持一致
    // #whiteboardContainer 有 overflow: auto，超出容器高度時顯示滾動條
    $("#whiteboardInner").css({ width: width + "px", height: height + "px" });
    // 重設 canvas 尺寸前先備份筆跡，因為修改 canvas.width/height 會清空畫布
    var dbCp = (_this.drawBuffer && _this.drawBuffer.length > 0)
      ? JSON.parse(JSON.stringify(_this.drawBuffer))
      : null;
    _this.canvas.width = width;
    _this.canvas.height = height;
    _this.imageHeight = height;
    _this.imageWidth = width;
    $("#loadingMedia").css({
      display: "none",
    });
    $("#loadingMedia").css({ zIndex: "0" });
    $(".pageChange").removeAttr("style");
    $("#whiteboardCanvas").css({ width: width, height: height });
    $("#textContainer").css({ width: width, height: height });
    $("#mouseOverlay").css({ width: width, height: height });
    $("#imgContainer").css({ width: width, height: height });
    $("#backgroundGrid").css({ width: width, height: height });
    $("#svgContainer").css({ width: width, height: height });
    $("#dropIndicator").css({ width: width, height: height });
    $("#cursorContainer").css({ width: width, height: height });

    const imgHeight = height;
    // 使用容器高度（非畫布高度）判斷是否需要垂直置中
    const containerHeight = _this.containerEl ? _this.containerEl.clientHeight : height;

    let transform, top;
    if (imgHeight < containerHeight) {
      transform = "translate(0px, -50%)";
      top = "50%";
    } else {
      transform = "translate(0px, 0px)";
      top = "0";
    }

    const position = { transform, top };

    $(
      "#whiteboardCanvas, #imgContainer, #backgroundGrid, #svgContainer, #dropIndicator, #cursorContainer, #textContainer, #mouseOverlay"
    ).css(position);
    // 畫布尺寸調整後重繪已有筆跡（避免清空後筆跡消失）
    if (dbCp && dbCp.length > 0) {
      _this.drawBuffer = [];
      _this.loadData(dbCp, false);
    }
  },
  async waitForFullImageDecode(img) {
    return new Promise((resolve) => {
      const check = () => {
        if (img.complete && img.naturalWidth > 0) {
          resolve(true);
        } else {
          requestAnimationFrame(check);
        }
      };
      check();
    });
  },
  userLeftWhiteboard(username) {
    this.cursorContainer.find("." + username).remove();
  },
  refreshUserBadges() {
    this.cursorContainer.find(".userbadge").remove();
  },
  getImageDataBase64(options, callback) {
    var _this = this;
    // var width = this.mouseOverlay.width();
    // var height = this.mouseOverlay.height();
    var width = this.imageWidth;
    var height = this.imageHeight;
    var copyCanvas = document.createElement("canvas");
    copyCanvas.width = width;
    copyCanvas.height = height;
    var imageFormat = options.imageFormat || "png";
    var drawBackgroundGrid = options.drawBackgroundGrid || false;
    var brackGroundImg = new Image();
    brackGroundImg.crossOrigin = "anonymous";
    brackGroundImg.src = this.backgroundUrl;

    try {
      brackGroundImg.onload = function () {
        var destCtx = copyCanvas.getContext("2d"); //Draw the maincanvas to the exportcanvas
        destCtx.fillStyle = "#FFFFFF";
        destCtx.fillRect(0, 0, width, height);

        if (imageFormat === "jpeg") {
          //Set white background for jpeg images
          destCtx.fillStyle = "#FFFFFF";
          destCtx.fillRect(0, 0, width, height);
        }

        if (drawBackgroundGrid) {
          destCtx.globalAlpha = 0.8;
          var ptrn = destCtx.createPattern(brackGroundImg, "repeat"); // Create a pattern with this image, and set it to "repeat".
          destCtx.fillStyle = ptrn;
          destCtx.fillRect(0, 0, copyCanvas.width, copyCanvas.height); // context.fillRect(x, y, width, height);
          destCtx.globalAlpha = 1;
        }

        $.each(_this.imgContainer.find("img"), function () {
          //Draw Backgroundimages to the export canvas
          var width = $(this).width();
          var height = $(this).height();
          var p = $(this).position();
          var left = Math.round(p.left * 100) / 100;
          var top = Math.round(p.top * 100) / 100;
          destCtx.drawImage(this, left, top, width, height);
        });

        //Copy drawings
        destCtx.drawImage(_this.canvas, 0, 0);

        var textBoxCnt = 0;
        $.each($(".textBox"), function () {
          //Draw the text on top
          textBoxCnt++;

          var textContainer = $(this);
          var p = textContainer.position();

          var left = Math.round(p.left * 100) / 100;
          var top = Math.round(p.top * 100) / 100;

          html2canvas(
            this,
            {
              backgroundColor: "rgba(0, 0, 0, 0)",
              removeContainer: true,
            },
            { useCORS: true }
          ).then(function (canvas) {
            destCtx.drawImage(canvas, left, top);
            textBoxCnt--;
            checkForReturn();
          });
        });

        function checkForReturn() {
          // console.error("test", textBoxCnt)
          if (textBoxCnt == 0) {
            try {
              var url = copyCanvas.toDataURL("image/" + imageFormat);
              callback(url);
            } catch (e) {
              console.warn("toDataURL failed (tainted canvas):", e.message);
            }
          }
        }
        checkForReturn();
      };
    } catch (error) {
      console.log(error);
    }
  },
  getImageDataJson() {
    var sendObj = [];
    for (var i = 0; i < this.drawBuffer.length; i++) {
      sendObj.push(JSON.parse(JSON.stringify(this.drawBuffer[i])));
      delete sendObj[i]["username"];
      delete sendObj[i]["wid"];
      delete sendObj[i]["drawId"];
    }
    return JSON.stringify(sendObj, null, 2);
  },
  loadData: function (content, isNewData = true) {
    var _this = this;
    _this.loadDataInSteps(content, isNewData, function (stepData) {
      if (
        stepData["username"] == _this.settings.username &&
        _this.drawId < stepData["drawId"]
      ) {
        _this.drawId = stepData["drawId"] + 1;
      }
    });
  },
  loadDataFullscreen: function (content, isNewData = true, size) {
    var _this = this;
    var _this = this;
    _this.loadDataInStepsFullscreen(
      content,
      isNewData,
      function (stepData) {
        if (
          stepData["username"] == _this.settings.username &&
          _this.drawId < stepData["drawId"]
        ) {
          _this.drawId = stepData["drawId"] + 1;
        }
      },
      function () {
        setTimeout(() => {
          const width = size[0];
          const originalWidth = size[1];
          _this.setStrokeThickness((_this.thickness * width) / originalWidth);
        }, 50);
      }
    );
  },
  loadDataInStepsFullscreen(
    content,
    isNewData,
    callAfterEveryStep,
    onComplete
  ) {
    var _this = this;
    if (content && Array.isArray(content)) {
      content = content?.filter((item, index, arr) => {
        return (
          item["t"] !== "addImgContentAsBG" ||
          arr.findIndex((el) => el["t"] === "addImgContentAsBG") === index
        );
      });
    }

    async function lData(index) {
      for (var i = index; i < content?.length; i++) {
        if (content[i]["t"] === "addImgBG" && content[i]["draw"] == "1") {
          _this.handleEventsAndData(content[i], isNewData, function () {
            callAfterEveryStep(content[i], i);
            lData(i + 1);
          });
          return; // Exit the loop to avoid duplicate calls
        } else if (content[i]["t"] === "addImgContentAsBG") {
          _this.handleEventsAndData(content[i], isNewData, async function () {
            await callAfterEveryStep(content[i], i);
            lData(i + 1);
            setTimeout(() => {}, 0);
          });
          return; // Exit the loop to avoid duplicate calls
        } else {
          _this.handleEventsAndData(content[i], isNewData);
          callAfterEveryStep(content[i], i);
        }
      }

      // If the loop completes without returning, call onComplete
      if (onComplete) onComplete();
    }

    lData(0);
  },
  loadCurrentData(drawBuffer, isNewData = true) {
    var _this = this;
    const dbCp = JSON.parse(JSON.stringify(drawBuffer));

    const requiredElements = [
      "ctx", // Canvas context
      "backgroundGrid", // Background grid element
      "imgContainer", // Image container
      "canvasElement", // Whiteboard canvas
      "svgContainer", // SVG container
      "dropIndicator", // Drag/drop indicator
      "cursorContainer", // Cursor container
      "textContainer", // Text container
      "mouseOverlay", // Mouse overlay
    ];

    function checkDependencies() {
      // Check if all required elements exist and are truthy
      const allReady = requiredElements.every((element) => !!_this[element]);

      if (allReady) {
        console.log("All elements are exist");
        // Proceed when all elements are available
        _this.loadData(dbCp, isNewData);
      } else {
        // Retry check if any element is missing
        setTimeout(checkDependencies, 100);
      }
    }

    // Initial check
    checkDependencies();
  },
  loadDataInSteps(content, isNewData, callAfterEveryStep) {
    var _this = this;
    if (content && Array.isArray(content)) {
      content = content?.filter((item, index, arr) => {
        return (
          item["t"] !== "addImgContentAsBG" ||
          arr.findIndex((el) => el["t"] === "addImgContentAsBG") === index
        );
      });
    }

    async function lData(index) {
      for (var i = index; i < content?.length; i++) {
        if (content[i]["t"] === "addImgBG" && content[i]["draw"] == "1") {
          _this.handleEventsAndData(content[i], isNewData, function () {
            callAfterEveryStep(content[i], i);
            lData(i + 1);
          });
          break;
        } else if (content[i]["t"] === "addImgContentAsBG") {
          _this.handleEventsAndData(content[i], isNewData, async function () {
            await callAfterEveryStep(content[i], i);
            lData(i + 1);
            setTimeout(() => {}, 0);
          });

          break;
        } else {
          _this.handleEventsAndData(content[i], isNewData);
          callAfterEveryStep(content[i], i);
        }
      }
    }
    lData(0);
  },
  loadJsonData(content, isNewData = true, doneCallback) {
    var _this = this;
    // console.log("content", content);
    _this.loadDataInSteps(content, true, async function (stepData, index) {
      // _this.sendFunction(stepData, isNewData);
      if (index >= content.length - 1) {
        //Done with all data
        _this.drawId++;
        if (doneCallback) {
          doneCallback();
        }
      }
    });
  },
  updatePositionData(content, isNewData = true, doneCallback) {
    var _this = this;
    _this.loadDataInSteps(content, true, async function (stepData, index) {
      _this.sendFunction(stepData, isNewData);
      if (index >= content.length - 1) {
        //Done with all data
        _this.drawId++;
        if (doneCallback) {
          doneCallback();
        }
      }
    });
  },
  sendFunction: function (content, isNewData = true) {
    //Sends every draw to server
    var _this = this;
    content["wid"] = _this.settings.whiteboardId;
    content["username"] = _this.settings.username;
    content["drawId"] = _this.drawId;

    var tool = content["t"];
    if (_this.settings.sendFunction && isNewData) {
      _this.settings.sendFunction(content);
    }
    if (
      isNewData &&
      [
        "line",
        "arrow",
        "pen",
        "rect",
        "triangle",
        "circle",
        "ellipse",
        "eraser",
        "addImgBG",
        "addImgContentAsBG",
        "recSelect",
        "eraseRec",
        "addTextBox",
        "setTextboxText",
        "removeTextbox",
        "setTextboxPosition",
        "setTextboxFontSize",
        "setTextboxFontColor",
        "setTextboxBackgroundColor",
      ].includes(tool)
    ) {
      _this.drawBuffer.push(content);
    }
  },
  refreshCursorAppearance() {
    //Set cursor depending on current active tool
    var _this = this;
    if (_this.tool === "pen" || _this.tool === "eraser") {
      _this.mouseOverlay.css({ cursor: "none" });
    } else if (_this.tool === "mouse") {
      this.mouseOverlay.css({ cursor: "default" });
    } else {
      //Line, Rec, Circle, Cutting
      _this.mouseOverlay.css({ cursor: "crosshair" });
    }
  },
};

function lanczosKernel(x) {
  if (x == 0) {
    return 1.0;
  }
  return (
    (2 * Math.sin(Math.PI * x) * Math.sin((Math.PI * x) / 2)) /
    Math.pow(Math.PI * x, 2)
  );
}

function lanczosInterpolate(xm1, ym1, x0, y0, x1, y1, x2, y2, a) {
  var cm1 = lanczosKernel(1 + a);
  var c0 = lanczosKernel(a);
  var c1 = lanczosKernel(1 - a);
  var c2 = lanczosKernel(2 - a);
  var delta = (cm1 + c0 + c1 + c2 - 1) / 4;
  cm1 -= delta;
  c0 -= delta;
  c1 -= delta;
  c2 -= delta;
  return [
    cm1 * xm1 + c0 * x0 + c1 * x1 + c2 * x2,
    cm1 * ym1 + c0 * y0 + c1 * y1 + c2 * y2,
  ];
}

function testImage(url, callback, timeout) {
  timeout = timeout || 5000;
  var timedOut = false,
    timer;
  var img = new Image();
  img.onerror = img.onabort = function () {
    if (!timedOut) {
      clearTimeout(timer);
      callback(false);
    }
  };
  img.onload = function () {
    if (!timedOut) {
      clearTimeout(timer);
      callback(true);
    }
  };
  img.src = url;
  timer = setTimeout(function () {
    timedOut = true;
    // reset .src to invalid URL so it stops previous
    // loading, but doesn't trigger new load
    img.src = "//!!!!/test.jpg";
    callback(false);
  }, timeout);
}

// Object.defineProperty(whiteboard, "drawBuffer", {
//   configurable: true,
//   get() {
//     return this._drawBuffer;
//   },
//   set(v) {
//     // console.error("drawBuffer changed:", v, new Error().stack);
//     this._drawBuffer = v;
//   },
// });
// whiteboard._drawBuffer = whiteboard.drawBuffer;


export default whiteboard;
